<template>
  <div 
      :style="`
              --addBtnColor: ${colors.addBtnColor};
              --addBtnColorInv: ${colors.addBtnColorInv}; 
              --iconsColor1: ${colors.iconsColor1}; 
              --iconsColor2: ${colors.iconsColor2}; 
              --secundar: ${colors.secundarColor}; 
              --principal: ${colors.principalColor}; 
              --white: ${whiteColor};
            `"
      :class="[
        'order_view', 
        (json.type != 'Kiosk') ? 'mobile' : 'kiosk',
        'comp_' + json.company_id
      ]"
      @click="detectActivity"
    >
    <div :class="(loader) ? 'loader' : 'loader none'">
      <div class="el-loading-spinner">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
      </div>
    </div>
    <div v-if="(cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips) && json.type != 'Kiosk ' && json.type == 'mobile'" class="fastTip">
      <button v-if="(cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips)" @click="addOrRemoveTip(1, true)">+ Tips / Bacșiș</button>
    </div>
    <!-- <div v-if="!error && banners && banners.length"
      :class="(banners && banners.length && activeProductList.top && json.type != 'Kiosk') ? 'banner bannerHidden' : 'banner'" 
      >
      <swiper
        :modules="swiperModule"
        effect="fade"
        v-if="banners && banners.length"
        scrollbar
        :loop="true"
        :grabCursor="false"
        :centeredSlides="true"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
          waitForTransition: false
        }"
        class="special-offer-block focus-in"
       >
        <swiper-slide
          v-for="(slider, index) in banners"
          :key="index + 'slider'">
          <a @click="redirectFromImage(slider)">
            <div class="banner_img" 
                  :style="'background-image: URL('+slider.image_banner+');'" 
                  :alt="'Special Offer' + index"></div>
          </a>
        </swiper-slide>
      </swiper>
    </div> -->

    
    <!-- <div :class="[
        'orderspos',
        (banners && banners.length && activeProductList.top && json.type != 'Kiosk') ? 'bannerHidden' : (banners && banners.length) ? 'withBanner' : 'noBanner',
        (cart && cart.myCart && cart.myCart.products_count > 0) ? 'noToolbar' : 'noToolbar',
        (cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips) && json.type != 'Kiosk' && json.type == 'mobile' ? 'withFastTip' : 'noFastTip'
      ]" v-if="!error"> -->
      <div :class="[
        'orderspos',
        'noBanner',  // Adaugăm noBanner constant
        (cart && cart.myCart && cart.myCart.products_count > 0) ? 'noToolbar' : 'noToolbar',
        (cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips && json.type != 'Kiosk' && json.type == 'mobile') ? 'withFastTip' : 'noFastTip'
      ]" v-if="!error">


      <div class="productList_wrapper">
      
        <div class="topBar">
          <div class="backButton" @click="openShowSplashScreenModal()">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.menuNavbar')}}
          </div>
          <div class="cart" @click="showCart()">
            <img src="../../public/cart.svg">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        
        <div :class="[
          (this.json.type != 'Kiosk' && top_category && top_category.length && selectedTopCategory && top_category.filter(el => el.id == selectedTopCategory)  && top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1) ? 'with_filter2' : 'no_filter2',
          'productList_wrapper_left'
        ]">
          <div v-if="json.type != 'Kiosk' && json.company_id == 39" 
            :class="(listOfLangIsOpen) ? 'lang_btn open' : 'lang_btn' "
            style="position: absolute; right: 10px; top: 10px; z-index: 1;"
          >
            <a @click.prevent="openListOfLang()">
              <img :src="'../' + curentLang + '.png'" alt="lang">
            </a>
            <div class="listOfLang">
              <template v-for="lng in allLang" :key="lng">
                <a @click.prevent="changeLanguageLocal(lng)" v-if="lng != curentLang">
                  <img :src="'../' + lng + '.png'" alt="lng">
                </a>
              </template>
            </div>
          </div>
          <div class="filter">
            <div :class="['filter__bar',
            ]">
              <div class="filter__cat">
                <template v-for="top in top_category" :key="top.id">
                  <div :class="[
                        ((top.id == selectedTopCategory && this.json.type == 'Kiosk') ? 'topGroup active' : 'topGroup'), 
                        top.id + ' ' //for scroolTopCategory() function
                        ]">
                    <a @click="getTop(top)" :class="(top.id == selectedTopCategory) ? 'selected ' + top.id : '' + top.id ">
                        <p>{{top.name}}</p>
                        <div class="cat_photo" :style="'background-image: url('+top.image+');'" ></div>
                    </a>
                    <div class="childs" v-if="this.json.type == 'Kiosk'">
                      <template v-for="cat in top.categories" :key="cat.id">
                        <a @click="getProducts(cat.id, top.id)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                          <p>{{cat.name}}</p>
                          <div class="cat_photo" :style="'background-image: url('+cat.image+');'" ></div>
                        </a>
                      </template>
                    </div>
                  </div>
                </template>
                <template v-for="cat in category" :key="cat.id">
                  <a @click="getProducts(cat.id, null)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                    <p>{{cat.name}}</p>
                    <div class="cat_photo" :style="'background-image: url('+cat.image+');'" ></div>
                  </a>
                </template>
              </div>
            </div>
          </div>
          <div class="filter filter2"  v-if="this.json.type != 'Kiosk' && top_category && top_category.length  && selectedTopCategory && this.top_category.filter(el => el.id == selectedTopCategory) && this.top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1">
            <div class="filter__bar">
              <div class="filter__cat">
                <template v-for="cat in this.top_category.filter(el => el.id == selectedTopCategory)[0].categories" :key="cat.id">
                  <a @click="getProducts(cat.id, this.top_category.filter(el => el.id == selectedTopCategory)[0].id)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                    <p>{{cat.name}}</p>
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div :class="[
          (this.json.type != 'Kiosk' && top_category && top_category.length && selectedTopCategory && this.top_category.filter(el => el.id == selectedTopCategory) && this.top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1) ? 'with_filter2' : 'no_filter2',
          'productList_wrapper_right'
          ]">
          <div class="search_topBar">
            <div class="search_wrapper">
              <div class="filter__search showw">
                <div class="search">
                  <span class="icosearch">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.414" height="29.414" viewBox="0 0 29.414 29.414">
                      <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-3.5 -3.5)">
                        <path id="Path_2498" data-name="Path 2498" d="M28.5,16.5a12,12,0,1,1-12-12A12,12,0,0,1,28.5,16.5Z" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_2499" data-name="Path 2499" d="M31.5,31.5l-6.525-6.525" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </g>
                    </svg>
                  </span>
                  <input type="text" ref="searchText" :placeholder="$t('addOrder.search')" v-model="searchText" @keyup.enter="newText()">
                  <span :class="showRemoveTextFromSearch ? 'closeSearch show' : 'closeSearch' " @click="deleteTextFromSearchMobile()">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 460.775 460.775" style="enable-background:new 0 0 460.775 460.775;" xml:space="preserve">
                      <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                        c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                        c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                        c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                        l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                        c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                  </span>
                  <button @click="newText()">{{ $t('general.search') }}</button>
                </div>
              </div>
            </div>
          </div>
          
          <div :class="['productList__wrapper']">
            <div class="productList" :style="(loading ? 'overflow: hidden;' : '')">
              <template v-if="!loading">
                <template v-if="products.length">
                  <template v-for="product in products" :key="product.id">
                    <div :class="product.is_highlight ? 'product is_highlight' : 'product'" :ref="'product' + product.id" @click="openProduct(product)">
                      <div class="product_img_title">
                        <div class="productImage__wrapper">
                          <template v-if="product.image_url">
                            <div 
                              class="productImage"
                              :style="{
                                  backgroundImage: 'url(' + encodeURI(product.image_url) + ')',
                                  backgroundSize: product.image_size ? product.image_size : ''
                              }">
                            </div>
                            <p class="discount_badge" v-if="product.old_price > 0">{{Math.ceil(( product.old_price - product.price_details.price ) / product.old_price * 100)}} %</p>
                          </template>
                        </div>
                        <div class="prodTitle__wrapper">
                          <p class="prod_title">{{product.name}}</p>
                          <p class="prod_description" v-if="product.description">{{product.description}}</p>
                        </div>

                        <div class="wrepperPrice">
                          <template v-if="product.use_price_to_show && product.price_to_show > 0">
                            <p v-if="!(json.company_id == 39 && product.price_details.price <= 0)" class="prod_price" v-html="product.price_to_show + ' ' + product.price_details.currency_symbol"></p>
                          </template>
                          <template v-else>
                            <p class="old_prod_price" v-if="product.old_price > 0" v-html="product.old_price + ' ' + product.price_details.currency_symbol"></p>
                            <p v-if="!(json.company_id == 39 && product.price_details.price <= 0) && product.price_details.price != '0'" class="prod_price" v-html="product.price_details.formatted_price"></p>
                            <p @click.stop="addProductDirectlyToCart(product)" class="prod_addDirectToCart" v-if="json.company_id == 39">+</p>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div class="no-products-found">{{ $t('addOrder.noProductsFound') }}</div>
                </template>
              </template>
              <div :class="(loading ? 'show-loader' : 'hide-loader')">
                <div class="el-loading-spinner">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="error error_page" v-if="error">
      <h1>
        <template v-if="errorType" class="jumping">
          {{$t('general.error_not_open_table_'+ errorType)}}
        </template>
        <template v-else>
          {{$t('general.error_not_open_table')}}
        </template>
      </h1>
    </div>

    <vue-final-modal
            name="productModal"
            v-model="showProductModal"
            :hideOverlay="true"
            :class="['productModal', showProductModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <div class="topBar">
          <div class="backButton" @click="showProductModal = false">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.productNavbar')}}
          </div>
          <div class="cart" @click="showCart()">
            <img src="../../public/cart.svg">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        <div class="product">
          <template v-if="currentProductInPopup && currentProductInPopup.image_url && currentProductInPopup.image_url[0]['url']">
            <span style=""></span>
            <div 
              class="photo"
              :style="{
                backgroundImage: 'url(' + encodeURI(currentProductInPopup.image_url[0].url) + ')',
                backgroundSize: currentProductInPopup.image_size ? currentProductInPopup.image_size : ''
              }">
            </div>
          </template>
          <div class="prod_white" style="background: #F5F5F5; position: relative; z-index: 2;">
            <div class="productModal__product" v-if="currentProductInPopup">
              <div class="title__wraper">
                <div class="title">
                  <p>{{currentProductInPopup.name}}</p>
                </div>
                <div class="price">
                  <template v-if="currentProductInPopup.use_price_to_show && currentProductInPopup.price_to_show > 0">
                    <p v-html="currentProductInPopup.price_to_show + ' ' + currentProductInPopup.price_details.currency_symbol"></p>
                  </template>
                  <template v-else>
                    <p v-if="currentProductInPopup.price_details.price" v-html="currentProductInPopup.price_details.formatted_price"></p>
                  </template>
                </div>
                <div>
                  <p>{{currentProductInPopup.description}}</p>
                  <!-- <template v-if="currentProductInPopup.description && currentProductInPopup.description.length > 255">
                    <p>{{currentProductInPopup.description.substring(0, 255)}}...</p>
                  </template>
                  <template v-else>
                    <p>{{currentProductInPopup.description}}</p>
                  </template> -->
                </div>
              </div>
            </div>

            <div class="gray__prod_wrapper">
              <ProductOptionsTable 
              v-if="!optionsInSteps && currentProductInPopup && currentProductInPopup.product_options && currentProductInPopup.product_options.length"
              :currentProductInPopup="currentProductInPopup"
              @update-categories="updateCategories"
              ></ProductOptionsTable>

              <div class="other_info" v-if="currentProductInPopup && currentProductInPopup.other_info.length">
                  <div class="info" v-for="other_info in currentProductInPopup.other_info" :key="other_info.id" @click="(isExpended == other_info.id) ? isExpended = null : isExpended = other_info.id">
                    <h2>{{other_info.title}}</h2>
                    <div class="other_info_ico">
                      <svg :class="(isExpended != other_info.id) ? 'closed' : ''" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                          viewBox="0 0 460.775 460.775" style="enable-background:new 0 0 460.775 460.775;" xml:space="preserve">
                            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                              c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                              c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                              c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                              l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                              c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                      </svg>
                    </div>
                    <Collapse as="section" :when="isExpended == other_info.id" class="collapse_class">
                      <div class="description">
                        <p v-html="other_info.description"></p>
                      </div>
                    </Collapse>
                  </div>
              </div>

              <div class="info__wrapper" v-if="currentProductInPopup && currentProductInPopup.allow_user_comments">
                <textarea name="info" :placeholder="$t('addOrder.infosup')" v-model="currentProductInPopup.additional_info"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer" v-if="currentProductInPopup">
        <div class="footer__quantity">
          <button :disabled="currentProductInPopup.quantity <= 1" @click="updateQuantity(currentProductInPopup, 0)">-</button>
          <span>{{currentProductInPopup.quantity}}</span>
          <button @click="updateQuantity(currentProductInPopup, 1)">+</button>
        </div>
        <div class="footer__right">
          <div class="footer__addToCart">
            <template v-if="optionsInSteps">
              <button @click="nextOptionToCart(1,1)">
                {{$t('addOrder.next_to_option')}}
              </button>
            </template>
            <template v-else>
              <template v-if="currentProductInPopup.in_edit">
                <button :disabled="addToCartDisabled" @click="editToCart()">
                {{$t('addOrder.edit')}}</button>
              </template>
              <template v-else>
                <button :disabled="addToCartDisabled" @click="addToCart()">
                  {{$t(optionsInSteps ? 'addOrder.add' : 'addOrder.addFor')}}
                  <template v-if="!optionsInSteps">
                    <span v-html="' ' + currentProductInPopup.price_details.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                  </template>
                </button>
              </template>
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="optionModal"
            v-model="showOptionModal"
            :hideOverlay="true"
            :class="['optionModal', showOptionModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <div class="topBar">
          <div class="backButton" @click="nextOptionToCart(-1)">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.optionNavar')}}
          </div>
          <div class="cart" @click="showCart()">
            <img src="../../public/cart.svg">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        <template v-if="currentOptionInPopup && currentOptionInPopup.company_option && currentOptionInPopup.company_option.image">
          <template v-if="!currentOptionInPopup.image.includes('/placeholder.')">
            <div class="photo" :style="'background-image: url('+currentOptionInPopup.image+');'"></div>
          </template>
        </template>
        <div class="prod_white" style="background: #F5F5F5; position: relative; z-index: 2;">
          <div class="productModal__product" v-if="currentOptionInPopup">
            <div class="title" v-if="currentOptionInPopup">
              {{currentOptionInPopup.name}}
            </div>
            <div class="title__wraper">
              <div class="minMax" v-if="currentOptionInPopup.type == 'radio' && currentOptionInPopup.values.length > 1 && currentOptionInPopup.required">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                    <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#E2B5BF" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <div>
                    <span>{{$t('addOrder.selectMinMax')}}</span> 
                    <span>{{$t('addOrder.selectMin')}} 1</span> 
                  </div>
              </div>
              <div class="minMax" v-if="currentOptionInPopup.min_no || currentOptionInPopup.max_no">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                    <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#E2B5BF" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <div>
                    <span>{{$t('addOrder.selectMinMax')}}</span> 
                    <span v-if="currentOptionInPopup.min_no">{{$t('addOrder.selectMin')}} {{currentOptionInPopup.min_no}}</span> 
                    <span v-if="currentOptionInPopup.max_no">{{$t('addOrder.selectMax')}} {{currentOptionInPopup.max_no}}</span>
                  </div>
              </div>
            </div>
          </div>

          <div class="options__wrapper" v-if="currentOptionInPopup">
            <div class="option">
              <div class="options">
                <div v-for="(values, keyVal) in currentOptionInPopup.values" :key="values.id" class="withPhoto">
                  <label :for="values.id" :class="{ 'checked': values.checked}">
                    <template v-if="(currentOptionInPopup.type === 'checkbox')">
                      <input :type="currentOptionInPopup.type"
                          :ref="'ref_' + values.id"
                          :name="currentOptionInPopup.id"
                          :disabled="values.disabled"
                          :value="values.id"
                          :id="values.id"
                          @change="updateCategories(currentOptionInPopup.id, values.id)"
                          v-model="values.checked"
                    >
                    <button @click="clickOnRef('ref_' + values.id)" :class="['option_button', values.disabled ? 'disabled' : '']">
                      <div class="col-photo">
                        <template v-if="currentOptionInPopup.values[keyVal].image.includes('/placeholder.')">
                          <div class="opt_photo" :style="'background-image: url('+companyLogo+');'" ></div>
                        </template>
                        <template v-else>
                          <div class="opt_photo" :style="'background-image: url('+currentOptionInPopup.values[keyVal].image+');'" ></div>
                        </template>
                      </div>
                      <div class="col-value">
                        <span>
                          {{values.name}} 
                        </span>
                        <template v-if="!currentProductInPopup.use_price_to_show">
                          <span v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                        </template>
                      </div>
                    </button>
                    </template>
                    <template v-else>
                      <input :type="currentOptionInPopup.type"
                          :ref="'ref_' + values.id"
                          :name="currentOptionInPopup.id"
                          :value="values.id"
                          :id="values.id"
                          @change="updateCategories(currentOptionInPopup.id, values.id)"
                          v-model="currentOptionInPopup.checked"
                    >
                    <button @click="clickOnRef('ref_' + values.id)" class="option_button">
                      <div class="col-photo">
                        <template v-if="currentOptionInPopup.values[keyVal].image.includes('/placeholder.')">
                          <div class="opt_photo" :style="'background-image: url('+companyLogo+');'" ></div>
                        </template>
                        <template v-else>
                          <div class="opt_photo" :style="'background-image: url('+currentOptionInPopup.values[keyVal].image+');'" ></div>
                        </template>
                      </div>
                      <div class="col-value">
                        <span>
                          {{values.name}} 
                        </span>
                        <template v-if="!currentProductInPopup.use_price_to_show">
                          <span v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                        </template>
                      </div>
                    </button>
                    </template>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer" v-if="currentProductInPopup">
        <div class="footer__price">
          <span>{{$t('addOrder.total')}}</span>
          <span v-html="currentProductInPopup.price_details.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
        </div>
        <div class="footer__right">
          <div class="footer__addToCart">
            <template v-if="optionsInSteps && currentOptionInPopup && !currentOptionInPopup.is_the_last_option">
              <button @click="nextOptionToCart()" :disabled="verifyIfOptionIsDisabled()">
                {{$t('addOrder.next_to_option')}}
              </button>
            </template>
            <template v-else>
              <template v-if="currentProductInPopup.in_edit">
                <button :disabled="addToCartDisabled" @click="editToCart()">
                {{$t('addOrder.edit')}}</button>
              </template>
              <template v-else>
                <button :disabled="addToCartDisabled" @click="addToCart()">
                {{$t('addOrder.add')}}</button>
              </template>
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="cartModal"
            v-model="showCartModal"
            :hideOverlay="true"
            :class="['cartModal', showCartModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="cart__wrapper">

        <div class="topBar">
          <div class="backButton" @click="showCartModal = false">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.cartDet')}}
          </div>
          <div class="cart" @click="showCart()">
            <img src="../../public/cart.svg">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>

        <div class="cartDetail">
          <div class="cartDetail__head">
            <div class="cartTitle" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <span v-if="json.type != 'Kiosk'">{{json.type}} {{json.number}}</span>
            </div>
            <div class="packing_method" v-if="packingMethod">
              <span><b>{{$t('addOrder.'+packingMethod+'_first')}}</b> {{$t('addOrder.'+packingMethod+'_second')}}</span>
            </div>
            <div class="deleteAll" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <button class="emptyCart" v-if="cart && cart.myCart && cart.myCart.products.length" @click="emptyCartWithQuestion()">
                <emptyCartSvg /> {{$t('addOrder.emptyCartBtn')}}
              </button>
            </div>
          </div>
          
          <div class="products" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
            <template v-if="json.type != 'Kiosk' && cart.myCart.hasMultipleFingerprint">
              <template v-for="(prodInThisFinger, this_finger) in cart.myCart.products_sortBy_fingerprint" v-bind:key="prodInThisFinger.fingerprint">
                <div :class="(this_finger == fingerprint) ? 'fgp my' : 'fgp' ">
                  <span class="fingerprint_title">{{this_finger}}</span>
                  <template v-for="prod in prodInThisFinger" v-bind:key="prod.id">
                    <div class="product" >
                      <div class="product_details_wrapper">
                        <div @click="modifyProduct(prod)" style="display: contents;">
                          <div v-if="!prod.image.includes('placeholder')" class="col-image">
                            <template v-if="prod.image">
                              <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.image) + ');'">
                              </div>
                            </template>
                          </div>

                          <div class="col-info">
                            <div class="description">
                              <span class="product__name">{{prod.name}}</span>
                              <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>
                              <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id != 39">
                                <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                              </div>
                            </div>

                            <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id == 39" style="font-size: 1.56rem;">
                              <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                            </div>
                          </div>
                        </div>
                        <div class="col-buttons">
                          <div class="quantity">
                            <button v-if="prod.quantity > 1" @click="editToCartUpdateQuantity(prod.quantity - 1, prod.id, prod.index)">-</button>
                            <button v-else @click="deleteProductCart(prod.id, prod.index)">
                              <emptyCartSvg />
                            </button>
                            <span>{{prod.quantity}}</span>
                            <button @click="editToCartUpdateQuantity(prod.quantity + 1, prod.id, prod.index)">+</button>
                          </div>
                          <div class="delete">
                            <template>
                              <button class="product__delete" @click="deleteProduct(prod.id, prod.index)"><emptyCartSvg /></button>
                            </template>
                          </div>
                        </div>
                      </div>
                      <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                      <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span>
                    </div>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-for="prod in cart.myCart.products" v-bind:key="prod.id">
                <div class="product">
                  <div class="product_details_wrapper">
                    <div @click="modifyProduct(prod)" style="display: contents;">
                      <div v-if="!prod.image.includes('placeholder')" class="col-image">
                        <template v-if="prod.image">
                          <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.image) + ');'">
                          </div>
                        </template>
                      </div>

                      <div class="col-info">
                        <div class="description">
                          <span class="product__name">{{prod.name}}</span>
                          <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>

                          <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id != 39">
                            <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                          </div>
                        </div>

                        <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id == 39" style="font-size: 1.56rem;">
                          <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-buttons">
                      <div class="quantity">
                        <button v-if="prod.quantity > 1" @click="editToCartUpdateQuantity(prod.quantity - 1, prod.id, prod.index)">-</button>
                        <button v-else @click="deleteProductCart(prod.id, prod.index)">
                          <emptyCartSvg />
                        </button>
                        <span>{{prod.quantity}}</span>
                        <button @click="editToCartUpdateQuantity(prod.quantity + 1, prod.id, prod.index)">+</button>
                      </div>
                    </div>
                  </div>
                  <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                  <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span>
                </div>
              </template>
            </template>
            
          </div>
          <div class="no_products_in_cart" v-if="cart && cart.myCart && cart.myCart.products_count <= 0 ">
            <p>{{$t('addOrder.empty')}}</p>
            <div class="middle">
              <svg xmlns="http://www.w3.org/2000/svg" width="49.288" height="49.275" viewBox="0 0 49.288 49.275">
                <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(3 3)">
                  <g id="Bag">
                    <path id="Path_33955" d="M31.613,33.054H11.64C4.3,33.054-1.326,30.56.273,20.525l1.862-13.6C3.12,1.916,6.515,0,9.493,0H33.847c3.022,0,6.22,2.061,7.359,6.924l1.862,13.6C44.425,29.427,38.95,33.054,31.613,33.054Z" transform="translate(0 10.221)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Path_33956" d="M20.718,9.727C20.718,4.355,16.09,0,10.381,0h0A10.68,10.68,0,0,0,3.043,2.834,9.446,9.446,0,0,0,0,9.727H0" transform="translate(11.224 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Line_192" d="M.544.458H.435" transform="translate(28.156 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Line_193" d="M.544.458H.435" transform="translate(14.205 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <div class="tipsBox" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && cart.use_tips">
            <div class="tipsInputsTitle">
              <span>{{$t('addOrder.addTip')}}</span>
            </div>
            <div v-if="!isCollapsed" class="tipsBoxCollpase">
              <div class="tipsInputs">
                <div class="col col-one" 
                    :class="{ selected: selectedTip === 5, disabled: customTip !== '' && customTip !== null }"
                    @click="addTipDirect(5)">
                  <img src="../../public/smile.png">
                  <span> +5%</span>
                </div>
                <div class="col col-two" 
                    :class="{ selected: selectedTip === 10, disabled: customTip !== '' && customTip !== null }"
                    @click="addTipDirect(10)">
                  <img src="../../public/star.png">
                  <span> +10%</span>
                </div>
                <div class="col col-three" 
                    :class="{ selected: selectedTip === 15, disabled: customTip !== '' && customTip !== null }"
                    @click="addTipDirect(15)">
                  <img src="../../public/love.png">
                  <span> +15%</span>
                </div>
              </div>
              <div class="custom-tip-input" :class="{ disabled: selectedTip !== null && (customTip === '' || customTip === null) }">
                <input type="number" v-model="customTip" :placeholder="$t('addOrder.addTipValue')" :disabled="selectedTip !== null">
                <button @click="addOrRemoveCustomTip">
                  {{ parseFloat(customTip) === parseFloat(cart.order_totals.find(({ name }) => name === 'Tip')?.value || '') ? $t('addOrder.removeTipButton') : $t('addOrder.addTipButton') }}
                </button>
              </div>
            </div>
          </div>
          <div class="couponBox" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && cart.use_coupon_discount">
            <div class="couponInputsTitle" @click="toggleCouponCollapse">
              <span>{{$t('addOrder.couponBtn')}}</span>
            </div>
            <div v-if="isCouponCollapsed" class="inputCoupn">
              <input
                type="text"
                @keyup.enter="toggleCoupon"
                v-model="couponText"
                :placeholder="$t('addOrder.couponPlaceholder')"
                name="couponCode"
                ref="couponCode"
                :disabled="couponApplied"
              >
              <button 
                @click="toggleCoupon">
                {{ couponApplied ? $t('addOrder.removeCouponButton') : $t('addOrder.couponButton') }}
              </button>
            </div>
          </div>

          <div class="commentClientsBox" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
            <div class="commentClientsTitle" @click="toggleCommentCollapse">
              <span>{{$t('addOrder.commentBtn')}}</span>
            </div>
            <div v-if="isCommentCollapsed" class="inputComment">
              <textarea name="info" v-model="orderComments" :placeholder="$t('addOrder.infosup')"></textarea>
            </div>
          </div>

          <div class="totalCart" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div class="orderTotalsOptions">
                <template v-for="totalsOptions in cart.order_totals" v-bind:key="totalsOptions.name">
                  <template v-if="totalsOptions.use">
                    <div class="totalsOptions" v-if="totalsOptions.value != 0">
                      <span>{{totalsOptions.name}}</span>
                      <span v-html="totalsOptions.value + ' ' + currency_symbol"></span>
                    </div>
                  </template>
                </template>
              </div>
              <div class="orderTotal">
                <div class="total">
                  <span>{{$t('addOrder.total')}}</span>
                </div>
                <div class="totalPrice">
                  <span v-html="cart.myCart.total_cart_price + ' ' + currency_symbol"></span>
                </div>
              </div>
          </div>
        </div>

        <div class="footer" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
            <div class="addToCart">
              <div class="addToCart__right">
                <button class="orderNow" @click="payNew()">{{$t('addOrder.orderNow')}}</button>
              </div>
            </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="paymentModal"
            v-model="showPaymentModal"
            :hideOverlay="true"
            :class="['paymentModal', showPaymentModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="payment__wrapper">
        <div class="topBar">
            <div class="backButton" @click="showPaymentModal = false">
              <img src="../../public/arrow_back.svg">
            </div>
            <div class="title">
              {{$t('addOrder.payNavbar')}}
            </div>
            <div class="cart" @click="showPaymentModal = false">
              <img src="../../public/cart.svg">
              <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
                <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
              </template>
            </div>
          </div>
        <div class="round">
          <div class="fidelity" v-if="use_smso">
            <div class="fidelityTitle" @click="toggleFidelityCollapse">
              <span>{{$t('addOrder.phoneFidelityTitle')}}</span>
            </div>
            <div class="fidelityBox" v-if="isFidelityCollapsed">
              <div class="email_fields">
                <span>{{$t('addOrder.phoneFieldsTitle1')}}</span>
                <div class="phone_key_wrapper">
                  <div v-show="!client && !new_client">
                    <div class="inputPhone" >
                      <MazPhoneNumberInput
                        ref="clientPhoneField"
                        @click="changePhone()"
                        v-model="phone_to_send"
                        v-model:country-code="countryCode"
                        show-code-on-list  
                        @update="resultsPhone = $event"
                      />
                      <button @click="searchForClientMobile()">{{$t('addOrder.phoneSearch')}}</button>
                    </div>
                  </div>

                  <div class="client_fields" v-show="client || new_client">
                    <p v-if="client">{{$t('addOrder.client')}} {{maskPhoneNumber(client.phone)}}</p>
                    <p v-if="new_client">{{$t('addOrder.newClient')}} {{maskPhoneNumber(order_phone)}}</p>
                    <p v-if="new_client && loyalty_in_use" class="new_client">{{$t('addOrder.new_client_fidelity')}}</p>
                    <button @click="removeClient()">{{$t('general.cancel')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cui">
            <div class="cuiTitle" @click="toggleCuiCollapse">
              <span>{{ $t('addOrder.cuiPlaceholder') }}</span>
            </div>
            <div class="cuiBox" v-if="isCuiCollapsed">
              <div class="cui_fields" v-if="json.type != 'Kiosk'">
                <input id="cui" @click="changeCui()" type="text" v-model="cui" :placeholder="$t('addOrder.enterCui')">
              </div>
            </div>
          </div>
          <div class="titlePay">
            <p>{{$t('addOrder.howPay')}}</p>
          </div>
          <div class="pager_btn" v-if="json.type == 'Kiosk' && use_pager">
            <template v-if="pager">
              <button class="btnPager" @click="openPagerModal()">{{pager}}</button>
            </template>
            <template v-else>
              <button class="btnPager" @click="openPagerModal()">{{$t('addOrder.pagerBtn')}}</button>
            </template>
          </div>
          <div class="qr_code" v-if="qr_code">
            <div class="pack__wrapper__buttons_bg">
              <bgBtns />
            </div>
            <img :src="qr_code" alt="payByQr">
            <p><span>{{$t('addOrder.qrText')}}</span> <span> <div>{{countdown}}</div> </span> <span>{{$t('addOrder.qrText2')}}</span></p>
            <button class="qrCancel" @click="restart()">{{$t('addOrder.qrCancel')}}</button>
          </div>

          <div class="qr_code_steps" v-if="qr_code">
            <span>{{$t('addOrder.qrStep1')}}</span>
            <span>{{$t('addOrder.qrStep2')}}</span>
            <span>{{$t('addOrder.qrStep3')}}</span>
            <span>{{$t('addOrder.qrStep4')}}</span>
          </div>

          <div class="payment__buttons" v-if="!qr_code">
            <div :class="[disablePaymentClass, 'pos', 'load_card_pos']" @click="orderNow('card_pos')" v-if='posPaymentEnabled && cart && cart.myCart && cart.myCart.total_cart_price > 0'>
              <span>{{$t('addOrder.pos')}}</span>
            </div>
            <template v-if="json.type == 'Kiosk'">
              <div :class="[disablePaymentClass, 'take', 'load_k_qr']" @click="orderNow('qr')" v-if='cardPaymentEnabled'>
                <qrSvg />
                <span>{{$t('addOrder.qr')}}</span>
              </div>
              <div :class="[disablePaymentClass, 'din', 'load_k_cash']" @click="orderNow('cash')" v-if='cashPaymentEnabled'>
                <span>{{$t('addOrder.counter')}}</span>
              </div>
            </template>
            <template v-else>
              <div :class="[disablePaymentClass, 'take', 'load_card', { 'selected': selectedPaymentMethod === 'card', 'disabled': selectedPaymentMethod !== 'card' && selectedPaymentMethod !== '' && cardPaymentEnabled }]" @click="orderNow('card')" v-if='cardPaymentEnabled'>
                <span>{{$t('addOrder.card')}}</span>
                <div class="pay-image">
                  <div class="g-pay">
                    <img src="../../public/g-pay.svg">
                  </div>
                  <div class="g-pay">
                    <img src="../../public/apple-pay.svg">
                  </div>
                </div>
              </div>
              <div :class="[disablePaymentClass, 'din', 'load_cash', { 'selected': selectedPaymentMethod === 'cash', 'disabled': selectedPaymentMethod !== 'cash' && selectedPaymentMethod !== '' && cardPaymentEnabled }]" @click="orderNow('cash')" v-if='cashPaymentEnabled'>
                <span v-if="json.company_id == 190">{{$t('addOrder.cash_bar')}}</span>
                <span v-else>{{$t('addOrder.cash_waiter')}}</span>
              </div>
              <div :class="[disablePaymentClass, 'din', 'load_pos'], { 'selected': selectedPaymentMethod === 'pos', 'disabled': selectedPaymentMethod !== 'pos' && selectedPaymentMethod !== '' && cardPaymentEnabled }" @click="orderNow('pos')" v-if='posOnDeliveryPaymentEnabled'>
                <span v-if="json.company_id == 190">{{$t('addOrder.pos_bar')}}</span>
                <span v-else>{{$t('addOrder.pos_waiter')}}</span>
              </div>
            </template>
            <div :class="[disablePaymentClass, 'free', 'load_free'], { 'selected': selectedPaymentMethod === 'free', 'disabled': selectedPaymentMethod !== 'free' && selectedPaymentMethod !== '' && cardPaymentEnabled }" @click="orderNow('free')" v-if='freePaymentEnabled'>
              <span>{{$t('addOrder.free')}}</span>
            </div>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="splashScreenModal"
            v-model="showSplashScreenModal"
            :hideOverlay="true"
            :class="['splashScreenModal', showSplashScreenModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <template v-if="!packed && splashScreenBanners.length" v-for="(screen, key_s) in splashScreenBanners">
        <div :class="[nextSplashScreenSlider == key_s ? '' : 'hiden', 'splashScreen__wrapper']"  
            :style="'background-image: url(' + screen.image_landing + ');'"
        >
          <div class="languageBtns">
            <div 
              :class="['lang ro', curentLang == 'ro' ? 'selected' : '']" 
              @click.prevent="changeLanguageLocal('ro', 1)">
              <img src="../../public/ro-flag.svg">
            </div>
            <div 
              :class="['lang en', curentLang == 'en' ? 'selected' : '']" 
              @click.prevent="changeLanguageLocal('en', 1)">
              <img src="../../public/en-flag.svg">
            </div>
          </div>
          <div class="orderNowQr">
            <button @click="exitSplashScreen()" class="generalButton">{{$t('addOrder.splashScreenOrderNow')}}</button>
          </div>
          <div class="poweredByTaptasty">
            <poweredByTaptasty />
          </div>
        </div>
      </template>
      <div class="splashScreen__wrapper defaultOne" 
            v-if="splashScreenBanners.length <= 0"
            style="background-color: var(--principal)"
        >
        <div v-if="!companyLogo.includes('placeholder')" class="model">
          <img :src="companyLogo" alt="logo">
        </div>
        <div class="languageBtns">
          <div 
            :class="['lang ro', curentLang == 'ro' ? 'selected' : '']" 
            @click.prevent="changeLanguageLocal('ro', 1)">
            <img src="../../public/ro-flag.png">
          </div>
          <div 
            :class="['lang en', curentLang == 'en' ? 'selected' : '']" 
            @click.prevent="changeLanguageLocal('en', 1)">
            <img src="../../public/en-flag.png">
          </div>
        </div>
        <div class="orderNowQr">
          <button @click="exitSplashScreen()" class="generalButton">{{$t('addOrder.splashScreenOrderNow')}}</button>
        </div>
        <div class="poweredByTaptasty">
          <poweredByTaptasty />
        </div>
      </div>
      
    </vue-final-modal>

    <vue-final-modal
            name="completeModal"
            v-model="showCompleteModal"
            :hideOverlay="true"
            :class="['completeModal', showCompleteModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="complete__wrapper">

        <div class="top__pack__wrapper">
          <div class="model" style="position: relative;">
            <splashIcons width="100%" top="-100px" left="0" />
            <img :src="companyLogo" alt="logo">
          </div>
        
          <div class="round">
            <div class="roundbg"></div>

            <div class="title_wrapper">
              <div class="dialog" style="background-image: url('./dialog.png');">
                <span>{{$t('addOrder.doneShortly')}}</span>
              </div>
              <h2>{{$t('addOrder.thenks')}}</h2>
            </div>

            <div class="order_nr_wrapper">
              <div class="pack__wrapper__buttons_bg">
                <bgBtns />
              </div>
              <div class="order_nr">
                <svg xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
                  <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
                    <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
                      <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
                      <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
                    </g>
                  </g>
                </svg>
                <div class="order_nr_txt"> 
                  <span>{{$t('addOrder.yourOrderNr')}}</span>
                  <span>{{finishOrderNr}}</span>
                </div>
              </div>
            </div>

            <div class="steps">
              <div class="step">
                <div class="step_round">1</div>
                <span>{{$t('addOrder.step1')}}</span>
              </div>
              <div class="step">
                <div class="step_round">2</div>
                <span>{{$t('addOrder.step2')}}</span>
              </div>
            </div>

            <div class="back">
              <button @click="restart">{{$t('addOrder.back')}}</button>
            </div>
          </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="posModal"
            v-model="showPosModal"
            :hideOverlay="true"
            class="posModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="posModal__wrapper">

        <svg class="rotating" xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
          <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
            <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
              <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
              <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
            </g>
          </g>
        </svg>
        <h2>{{$t('addOrder.payByCard')}}</h2>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="couponModal"
            v-model="showCouponModal"
            :hideOverlay="true"
            class="couponModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="couponModal__wrapper" @click="closeCouponModal()">

        <div class="couponModal__img__wrapper">
          <couponSvg />
        </div>

        <h2>{{$t('addOrder.couponTitle')}}</h2>
        <input type="text" @keyup.enter="applyCoupon(true)" v-model="couponText" :placeholder="$t('addOrder.couponPlaceholder')" name="couponCode" ref="couponCode">
        <button v-if="json.type != 'Kiosk'" @click="applyCoupon(true)">{{$t('addOrder.couponBtn')}}</button>
        <span v-if="json.type == 'Kiosk'">{{$t('addOrder.couponExit')}}</span>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="pagerModal"
            v-model="showPagerModal"
            :hideOverlay="true"
            class="pagerModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="pagerModal__wrapper" @click="closePagerModal()">
        <div class="xModalBtn" @click="showPagerModal = false"><span>x</span></div>
        <div class="couponModal__img__wrapper">
          <img :src="'../pager.png'" alt="pager">
        </div>
        <h2>{{$t('addOrder.pagerTitle')}}</h2>
        <input type="text" @keyup.enter="applyPager()" id="pagerInput" ref="pagerInput" v-model="pagerText" :placeholder="$t('addOrder.pagerPlaceholder')" name="pagerInput">
        <span>{{$t('addOrder.couponExit')}}</span>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="soldWithModal"
            v-model="showSoldWithModal"
            :hideOverlay="true"
            :class="['soldWithModal', showSoldWithModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="soldWithModal__wrapper">
        <div class="topBar">
          <div class="backButton" @click="showSoldWithModal = false">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.soldWithTitle')}}
          </div>
          <div class="cart" @click="showCart()">
            <img src="../../public/cart.svg">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        
        <div class="products__wrapper">
          <template v-for="products in soldWithCategory" v-bind:key="products.id">
            
            <div class="SW_products" v-if="soldWithCategory && soldWithCategory.length > 0">
              <span class="cat_title">{{products.title}}</span>
              <template v-for="prod in products.products" v-bind:key="prod.id">
                <div :class="prod.active ? 'SW_product active' : 'SW_product' " @click="selectSoldWithProduct(prod)">
                  <div class="col-photo">
                      <template v-if="prod.src">
                        <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.src) + ');'">
                        </div>
                      </template>
                  </div>
                  <div class="col-info">
                    <div class="description">
                      <span class="product__name">{{prod.name}}</span>
                    </div>
                    
                    <div class="product_details">
                      <div class="product_price">
                        <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>

        <div class="soldWithBottomBar">
          <div class="soldWithBottomBar__right">
            <button class="soldWithAddBtn" @click="addTOCartExtra()" :disabled="!selectedSoldWithProducts.length">
              {{$t('addOrder.soldWithAdd')}}
            </button>
          </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="iframeModal"
            v-model="showIframeModal"
            :hideOverlay="true"
            class="iframeModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showIframeModal = false, onePaymentAllreadyPicked = false"><span>x</span></div>

        <iframe :src="paymentLinkForIframe" id="paymentFrame" frameborder="0"></iframe>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="settingsModal"
            v-model="showSettingsModal"
            :hideOverlay="true"
            class="settingsModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showSettingsModal = false; clearKeyBoard()"><span>x</span></div>
        <h1>Settings</h1>
        <div class="settings_buttons" v-if="!corectPass">
          <input type="text" v-model="thePass" placeholder="pass">
          <br>
          <button @click="verifyPass()">Enter</button>
        </div>
        <div class="settings_buttons" v-if="corectPass">
          <button @click="getRaport('Z')">GET Z</button>
          <br>
          <button @click="getRaport('X')">GET X</button>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="p9Modal"
            v-model="showP9Modal"
            :hideOverlay="true"
            class="p9Modal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showP9Modal = false; swiperTutorial.slideTo(0)"><span>x</span></div>
        
        <swiper
          :modules="swiperModuleTutorial"
          @swiper="onSwiperTutorial"
          effect="fade"
          scrollbar
          :loop="false"
          :grabCursor="false"
          :centeredSlides="true"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false
          }"
          class="swipper_tutorial special-offer-block focus-in"
        >
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_logo.png'" alt="p9_tutorial_logo">
              <h1>Bine ai venit la Piața9 Cetate!</h1>
              <h2 style="margin-bottom: 5px;">Dacă ești pentru prima dată te rugăm să iei în considerare câteva aspecte importante</h2>
              <button @click="swiperTutorial.slideTo(1)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s2.png'" alt="p9_tutorial_s2">
              <h2 style="margin-bottom: 0;">Comanda se face direct de la masă:  scanezi codul QR — adaugi produsele în coș — confirmi comanda.</h2>
              <button @click="swiperTutorial.slideTo(2)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s3.png'" alt="payment_tutorial3" style="width: 100%; max-width: 300px;">
              <h2 style="margin-bottom: 0;">Poți plăti direct online, la finalizarea comenzii, folosind Apple Pay, Google Wallet sau cardul bancar.</h2>
              <h2>Te rugăm să urmezi cu atenție toți pașii indicați de platformă și de aplicațiile terțe implicate.</h2>
              <button @click="swiperTutorial.slideTo(3)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s4.png'" alt="payment_tutorial4" style="width: 100%; max-width: 300px;">
              <h1>FOARTE IMPORTANT!</h1>
              <h2 style="margin-bottom: 5px;">Comanda ta este validată doar în momentul în care primești un mesaj clar de confirmare din partea noastră.</h2>
              <button @click="swiperTutorial.slideTo(4)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s5.png'" alt="payment_tutorial5" style="width: 100%; max-width: 300px;">
              <h2 style="margin-bottom: 0;">Ai și opțiunea să plătești cu NUMERAR sau cu CARDUL la POS.</h2>
              <h2>În acest caz, pentru a confirma comanda și a efectua plata, prezintă colegilor de la bar mesajul primit la finalizarea comenzii.</h2>
              <button @click="swiperTutorial.slideTo(5)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_logo.png'" alt="p9_tutorial_logo">
              <h2>Dacă ai orice fel de întrebare sau nelămurire, nu ezita să apelezi la colegii noștri prezenți în locație.</h2>
              <button @click="showP9Modal = false; swiperTutorial.slideTo(0)" class="settings_buttons_btn1">Comandă</button>
            </div>
          </swiper-slide>
        </swiper>

        
      </div>
    </vue-final-modal>

    <div id="swal-template"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { utilsMixin } from '../mixins/utils.js'
import { sharedFunction } from '../mixins/sharedFunction.js'
import Swal from 'sweetalert2'
import ProductOptionsTable from '../components/ProductOptionsTable';

import settingsSvg from './svg/settingsSvg';
import bgBtns from './svg/bgBtns';
import cardSvg from './svg/cardSvg';
import counterSvg from './svg/counterSvg';
import posSvg from './svg/posSvg';
import qrSvg from './svg/qrSvg';
import splashIcons from './svg/splashIcons';
import splashScreen from './svg/splashScreen';
import freeSvg from './svg/freeSvg';
import couponSvg from './svg/couponSvg';
import emptyCartSvg from './svg/emptyCartSvg';
import poweredByTaptasty from './svg/poweredByTaptasty';
export default {
  mixins: [utilsMixin, sharedFunction],
  name: 'OrderViewTable',
  components: {
    ProductOptionsTable,
    settingsSvg,
    bgBtns,
    cardSvg,
    counterSvg,
    posSvg,
    qrSvg,
    splashIcons,
    splashScreen,
    couponSvg,
    emptyCartSvg,
    freeSvg,
    poweredByTaptasty
  },
  props: {
    msg: String
  },
  data () {
    return {
      // in sharedFunction
      whiteColor: "#fff",
      isCollapsed: false,
      isCouponCollapsed: false,
      isFidelityCollapsed: false,
      isCommentCollapsed: false,
      isCuiCollapsed: false,
      products: [],
    }
  },
  mounted() {
    this.selectedTip = null;
    //remove keyboard on click
    let elNotKey = document.querySelector("html");
    elNotKey.addEventListener('touchend', (event) => {
      let keyEl = document.querySelector(".simple-keyboard");
      let langBtnEl = document.querySelector(".lang_btn");
      let langBtnEl2 = document.querySelector(".pack__wrapper .lang_btn");
      if (this.activeKeyboard && !keyEl.contains(event.target) ) {
        this.activeKeyboard = false;
      }
      if (!this.showSplashScreenModal && this.listOfLangIsOpen && !langBtnEl.contains(event.target) ) {
        this.listOfLangIsOpen = false;
      }
      if (this.showSplashScreenModal && this.listOfLangIsOpen && !langBtnEl2.contains(event.target)) {
        this.listOfLangIsOpen = false;
      }
    }, false);

    // handleGesture
    let touchableElement = document.querySelector(".productList");
    if (touchableElement) {
      touchableElement.addEventListener('touchstart', (event) => {
          this.touchstartX = event.changedTouches[0].screenX;
          this.touchstartY = event.changedTouches[0].screenY;
          // if(touchableElement.scrollTop + touchableElement.offsetHeight == touchableElement.scrollHeight) {
          if (touchableElement.scrollHeight - touchableElement.offsetHeight <= touchableElement.scrollTop + 2) {
            this.bottomReach = 1
          } else {
            this.bottomReach = 0
          }
          if(touchableElement.scrollTop == 0) {
            this.topReach = 1
          } else {
            this.topReach = 0
          }
      }, false);

      touchableElement.addEventListener('touchend', (event) => {
          this.touchendX = event.changedTouches[0].screenX;
          this.touchendY = event.changedTouches[0].screenY;
          this.handleGesture(touchableElement)
      }, false);

      // scrool effect
      this.setScroolVars(touchableElement, this.activeProductList)
      touchableElement.addEventListener('scroll', (event) => {
          this.setScroolVars(touchableElement, this.activeProductList)
          if (this.activeProductList.bottom == false && this.json.type == 'Kiosk') {
            this.infoShown.bottom = true
          } else {
            this.infoShown.bottom = false
          }
      }, false);
    }

    //disabled contextmenu
    if (!window.is_local) {
      document.addEventListener("contextmenu", function (e) {
          e.preventDefault();
      }, false);
    }

    // scrool effect
    let filterElement = document.querySelector(".filter__cat");
    if (filterElement) {
      this.setScroolVars(filterElement, this.activeFilter)
      filterElement.addEventListener('scroll', (event) => {
        this.setScroolVars(filterElement, this.activeFilter)
      }, false);
    }
  },
  created () {
    this.restart()
  },
  methods: {
    // in sharedFunction
    deleteProductCart(prodId, prodIndex) {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.emptyCartProduct'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: true,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteProduct(prodId, prodIndex)
        }
      })
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    toggleCouponCollapse() {
      this.isCouponCollapsed = !this.isCouponCollapsed;
    },
    toggleFidelityCollapse() {
      this.isFidelityCollapsed = !this.isFidelityCollapsed;
    },
    toggleCommentCollapse() {
      this.isCommentCollapsed = !this.isCommentCollapsed;
    },
    toggleCuiCollapse() {
      this.isCuiCollapsed = !this.isCuiCollapsed;
    }
  }
}
</script>

<style scoped lang="scss">
  @import "./scss/OrderViewMobile.scss";

  .poweredByTaptasty {
    position: relative;
    top: 20px;
    svg {
      max-width: 150px;
    }
  }
  .swal2-title {
    color: #000 !important;
  }
  .swal2-styled.swal2-confirm {
    font-size: 18px !important;
  }
  .mobile .productList_wrapper .productList_wrapper_right.with_filter2 .productList {
    margin-top: 25px;
  }
  .languageBtns {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    margin-bottom: 30px;
    z-index: 2;
    height: calc(100% - 160px);
    div {
      margin: 0px 8px;
      &.selected {
        img {
          height: 54px;
          border: 5px solid #ffff;
          border-radius: 16px;
        }
      }
      img {
        border-radius: 16px;
      }
    }
  }

  .soldWithModal,
  .cartModal {
    .backBar {
      position: relative;
      bottom: 0;
    }
  }
  .backBar {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 180px;
    width: 100%;
    z-index: 2;
    height: 100px;
    background: #fff;
    .backButon {
      font-size: 2rem;
      font-weight: 700;
      padding: 10px 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--addBtnColorInv);
      background: #fff;
      border: 1px solid var(--principal);
      svg {
        height: auto;
        width: 30px;
        margin-right: 12px;
        fill: var(--principal);
      }
    }
  }

  .minMax {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
    margin-top: 5px;
    color: #E2B5BF;
    background: transparent;
    border: 0;
    padding: 0;
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: 500;
  }
  .options__wrapper {
    margin: 10px;
    margin-top: 10px;
    border-radius: 20px;
    padding: 0px;
  }
  .options {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .withPhoto {
      width: calc(50% - 20px);
      margin-right: 10px;
      margin-left: 10px;
      margin-bottom: 12px;
      position: relative !important;
    }
    label {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // margin-bottom: 20px;
    }
    input {
      opacity: 0;
      position: absolute;
    }
    .col-photo {
      width: 40%;
    }
    .col-value {
      span {
        min-height: 70px;
        padding: 5px 2px;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        display: flex;
        font-size: 13px;
      }
    }
    .opt_photo {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 50px;
      height: 50px;
      margin-right: 5px;
      border-radius: 14px;
    }
    .option_button {
      // width: calc(100% - 40px);
      // margin-left: 20px;
      // margin-right: 20px;
      display: flex;
      // align-items: center;
      // justify-content: flex-start;
      border-radius: 10px;
      background: #fff;
      padding: 10px 20px;
      &.disabled {
        opacity: 0.5;
      }
      span {
        font-size: 1.7rem;
        margin-left: 20px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 2rem;
          color: #000;
        }
      }
    }
    input:checked ~ .option_button {
      background-color: var(--addBtnColor);
      color: var(--addBtnColorInv);;
      span {
        color: var(--addBtnColorInv);;
        span {
          color: var(--addBtnColorInv);;
        }
      }
    }
  }

  .fastTip {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index: 999;
    border-radius: 0;
    button {
      border-radius: 0;
      background: var(--principal);
      color: var(--secundar);
      width: 100%;
      height: 100%;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


  .swipeUpForMore {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 4;
    font-size: 12px;
    transition: 0.5s;
    opacity: 0;
    &.show {
      transition: 0.5s;
      opacity: 1;
    }
    svg {
      fill: var(--principal);
      transform: rotate(90deg);
      width: 40px;
    }
    span {
      color: var(--principal);
      margin-top: 10px;
    }
  }
  .posModal {
    .posModal__wrapper {
      position: relative;
      h2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin: 0;
        font-size: 3rem;
        font-weight: 700;
      }
    }
  }
  .soldWithModal {
    .soldWithBottomBar {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background: #f5f5f5;
      .soldWithBottomBar__right {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .soldWith_total_extra {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        background: #fff;
        color: var(--principal);
        span {
          &:first-of-type {
            font-size: 1.75rem;
            font-weight: 400;
          }
          &:last-of-type {
            font-size: 2.75rem;
            font-weight: 700;
          }
        }
      }
      .soldWithAddBtn {
        max-width: 350px;
        width: calc(100% - 20px);
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border: 0px;
        border-radius: 50px;
        background: var(--addBtnColor);
        padding: 20px 40px;
        height: 100%;
        margin-left: 40px;

        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          fill: #000;
          stroke: #000;
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }
        &:disabled {
          opacity: 0.5;
        }
      }
      .soldWithNoBtn {
        width: 30%;
        height: 100%;
        border: 1px solid #fff;
        background: transparent;
        padding: 20px;
        color: #fff;
        font-size: 1.87rem;
        font-weight: 400;
      }
    }
    .soldWithModal__wrapper {
      background: #F5F5F5;
      width: 100%;
      height: 100%;
    }
    .products__wrapper {
      // scrool div
      width: 100%;
      height: calc(100% - 440px);
      max-height: calc(100vh - 440px);
      padding: 0px 10px;
      overflow: auto;
    }
    .products__wrapper::-webkit-scrollbar {
        width: 5px;
    }
    .products__wrapper::-webkit-scrollbar-thumb {
        border-radius: 100px;
        border: 0px solid transparent;
        background-clip: content-box;
        background-color: var(--principal);
    }
    .products__wrapper::-webkit-scrollbar-track {
        background-color: #e4e4e4;
        border-radius: 100px;
    }
    .soldWithTopBar {
      width: 100%;
      height: 160px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 500;
      }
    }
    .soldWithBottomBar {
      width: 100%;
      height: 180px;
      padding: 20px;
    }
    .SW_products {
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-top: 60px;
      margin-bottom: 0px;
      position: relative;
      // border-bottom: 1px solid var(--secundar);
      span.cat_title {
        position: absolute;
        left: 10px;
        top: 30px;
        font-size: 18px;
        font-weight: 500;
        color: #000;
      }
      .SW_product {
        width: calc(33.33% - 20px);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 10px;
        margin-top: 0;
        margin-bottom: 30px;
        border-radius: 10px;
        background: #fff;
        padding: 10px;
        position: relative;
        &::after {
          content: "";
          background-image: url('../../public/add.svg');
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          top: -10px;
          right: -10px;
          width: 25px;
          height: 25px;
          pointer-events: none;
        }
        &.active {
          background: var(--principal);
          color: #fff;
          .product_price {
            color: #fff;
          }
          &::after {
            content: "";
            background-image: url('../../public/check.svg') !important;
            background: #0f6015;
            border: 2px solid #fff;
            background-repeat: no-repeat;
            border-radius: 50px;
            background-position: center;
            background-size: 13px;
            position: absolute;
            top: -10px;
            right: -10px;
            width: 25px;
            height: 25px;
            pointer-events: none;
          }
        }
        .col-photo {
          width: 40%;
        }
        .product__photo {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          width: 50px;
          height: 50px;
          margin-right: 8px;
          border-radius: 14px;
        }
        .description {
          font-size: 14px;
          font-weight: 500;
          margin-top: 0px;
          margin-bottom: 10px;
          text-align: left;
        }
        .product_price {
          font-size: 14px;
          font-weight: 500;
          color: var(--principal);
          margin-bottom: 20px;
          text-align: left;
        }
      }
    }
    
  }
  .pagerModal {
    .pagerModal__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 200px;
      .couponModal__img__wrapper {
        img {
          max-width: 300px;
        }
      }
    }
    h2 {
      font-size: 30px;
      font-weight: 500;
      color: #1F3D73;
    }
    input {
      width: 70%;
      border: 1px solid #1F3D73;
      border-radius: 4px;
      padding: 10px 15px;
      color: #1F3D73;
      text-align: center;
      font-size: 18px;
      &::placeholder {
        color: #1F3D73;
        opacity: 1; /* Firefox */
      }
    }
    span {
      color: var(--principal);
      position: absolute;
      left: 50%;
      bottom: 15px;
      transform: translateX(-50%);
      margin-bottom: 20px;
    }
  }
  .couponModal {
    .couponModal__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 200px;
      .couponModal__img__wrapper {
        img {
          max-width: 300px;
        }
      }
    }
    h2 {
      font-size: 30px;
      font-weight: 500;
      color: var(--iconsColor1);
    }
    input {
      width: 70%;
      border: 1px solid var(--iconsColor1);
      border-radius: 4px;
      padding: 10px 15px;
      color: var(--iconsColor1);
      text-align: center;
      font-size: 18px;
      &::placeholder {
        color: var(--iconsColor1);
        opacity: 1; /* Firefox */
      }
    }
    span {
      color: var(--principal);
      position: absolute;
      left: 50%;
      bottom: 15px;
      transform: translateX(-50%);
      margin-bottom: 20px;
    }
  }
  .iframeModal {
    .iframeModal__wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .payment__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    .payhBottomBar {
      width: 100%;
      margin-bottom: 30px;
      button {
        max-width: 350px;
        width: calc(100% - 20px) !important;
        height: 56px;
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border-radius: 50px;
      }
    }
    .round {
      width: 100%;
      height: 80%;
      position: absolute;
      left: 0;
      bottom: 0;
      padding-top: 20px;
      overflow: hidden;
      .cui {
        .cuiTitle {
          font-size: 18px;
          font-weight: 600;
          text-align: left;
          margin: 0 20px;
          padding-top: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #DFDFDF;
          span {
            text-decoration: underline;
          }
        }
        .cuiBox {
          input {
            border-radius: 50px;
            font-size: 14px;
            height: 43px;
            padding: 5px 20px;
            margin: 5px 0px;
            width: calc(100% - 40px);
            margin-bottom: 20px;
            box-shadow: initial;
            margin-top: 15px;
          }
        }
      }
      .fidelity {
        .fidelityTitle {
          font-size: 18px;
          font-weight: 600;
          text-align: left;
          margin: 0 20px;
          padding-top: 10px;
          border-bottom: 1px solid #DFDFDF;
          padding-bottom: 20px;
          color: green;
          span {
            text-decoration: underline;
          }
        }
      }
      .titlePay {
        p {
          font-size: 18px;
          font-weight: 600;
          text-align: left;
          padding: 0 20px;
          margin-bottom: 10px;
        }
      }
      .logo_t {
        position: absolute;
        left: 0;
        bottom: 5%;
        width: 100%;
      }
      h2 {
        position: relative;
        color: #fff;
        font-size: 4.37rem;
        font-weight: 400;
        margin-top: 0;
        margin-bottom: 0;
        z-index: 2;
      }
      .roundbg_wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
      }
      .roundbg {
        width: 200%;
        height: 100%;
        background: var(--principal);
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 0;
        border-top-right-radius: 50%;
        border-top-left-radius: 50%;
      }
    }
    .payment__tableName {
      font-size: 12px;
      z-index: 1;
      color: #fff;
      position: relative;
      margin-bottom: 10px;
      display: block;
    }
    .email_fields,
    .cui_fields {
      .client_fields {
        p {
          font-size: 18px;
        }
        button {
          height: 43px;
          padding: 10px 0px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
          border-radius: 50px;
        }
        .new_client {
          font-size: 14px;
          width: calc(100% - 40px);
          margin: auto;
          margin-bottom: 10px;
          font-style: italic;
        }
      }
      .inputPhone {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 350px !important;
        font-size: 1.5rem !important;
        margin: auto;
        margin-top: 10px !important;
        .m-input.--md {
          height: 4em !important;
          .m-input-wrapper-input {
            input {
              padding-left: 3.25rem !important;
              position: relative !important;
              top: 4px !important;
            }
          }
        }
        button {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 43px;
          padding: 10px 20px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
        }
      }
      input {
        width: 300px;
        font-size: 2rem;
        background: #fff;
        border: 0;
        border-radius: 10px;
        box-shadow: 0px 0px 20px -10px rgba(0, 0, 0, 0.75);
        padding: 10px 5px;
        text-align: left;
      }
    }
    .email_fields {
      span {
        position: relative;
        display: block;
        color: #000;
        padding: 10px 20px;
        text-align: left;
        font-size: 18px;
      }
      .inputPhone {
        width: 100%;
        max-width: 350px;
        font-size: 1rem;
        margin: auto;
        margin-top: 5px;
        @media screen and (max-width: 500px) {
          max-width: 300px;
        }
      }
      input {
        width: 100%;
        max-width: 350px;
        border-radius: 50px;
        font-size: 14px;
        height: 43px;
        padding: 5px 20px;
        margin: 5px 0px;
        box-shadow: none;
        text-align: left;
        @media screen and (max-width: 500px) {
          max-width: 300px;
        }
      }
    }
    .pager_btn {
      position: relative;
      z-index: 2;
      margin-bottom: 30px;
      .btnPager {
        position: relative;
        font-size: 2rem;
        width: 300px;
        font-weight: bold;
        background: var(--iconsColor1);
        color: var(--iconsColor2);
      }
    }
    .total {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: max-content;
      height: auto;
      margin: auto;
      color: var(--addBtnColorInv);
      background: var(--addBtnColor);
      z-index: 2222;
      position: relative;
      border-radius: 15px;
      padding: 20px 50px;
      margin-bottom: 20px;
      width: 300px;
      @media screen and (max-width: 500px) {
        width: 200px;
      }
      @media screen and (max-width: 400px) {
        width: 180px;
        margin-top: 10px;
      }
      span {
        display: block;
        &:first-of-type {
          font-size: 2.56rem;
          font-weight: 500;
        }
        &:last-of-type {
          font-size: 3.81rem;
          font-weight: 700;
        }
      }
    }
  }
  .qr_code {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60%;
    width: 100%;
    img {
      width: 510px;
      height: 510px;
      z-index: 2;
      padding: 10px;
      background: #fff;
      border-radius: 40px;
    }
    p {
      width: 500px;
      font-size: 2.25rem;
      font-weight: 400;
      color: #fff;
      margin: 0;
      margin-top: 20px;
      z-index: 2;
      span {
        min-width: 50px;
        >div {
          min-width: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .pack__wrapper__buttons_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120%;
      margin-top: -6.25rem;
      min-height: 500px;
    }
    .qrCancel {
      background: var(--addBtnColor);
      margin-top: 20px;
      color: var(--addBtnColorInv);
      font-size: 2.56rem;
      font-weight: 500;
      z-index: 2;
    }
  }
  .qr_code_steps {
    position: relative;
    width: 100%;
    height: 20%;
    padding-left: 40px;
    padding-right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 40px;
    span {
      font-size: 20px;
      font-weight: 300;
      font-style: italic;
      display: block;
      text-align: left;
      width: 100%;
    }
  }
  .order_view {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    &.withKey {
      height: calc(100vh - 450px);
    }
  }
  .swiper,
  .swiper-slide {
    width: 100%;
    height: 100%;
  }
  .banner {
    width: 100%;
    height: 500px;
    display: flex;
    .banner_img {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .hide-loader {
    display: none;
  }
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .productModal__wrapper {
    height: calc(100% - 100px);
    overflow: auto;
    margin-bottom: 100px;
  }
  .optionModal {
    .productModal__wrapper {
      .photo {
        // padding-bottom: 40%;
        // background-size: contain;
      }
      .prod_white {
        overflow: auto;
        height: calc(100% - 76px);
        .withPhoto {
          label {
            // position: relative !important;

            &::after {
              content: "";
              background-image: url('../../public/add.svg');
              background-size: contain;
              background-repeat: no-repeat;
              position: absolute;
              top: -10px;
              bottom: 0px;
              right: -10px;
              width: 25px;
              height: 25px;
              pointer-events: none;
            }
          }
          label.checked {
            // position: relative;
            &::after {
              content: '';
              background-image: url('../../public/check.svg') !important;
              background: #0f6015;
              border: 2px solid #fff;
              background-repeat: no-repeat;
              border-radius: 50px;
              background-position: center;
              background-size: 13px;
              position: absolute;
              top: -10px;
              bottom: 0px;
              right: -10px;
              width: 25px;
              height: 25px;
              pointer-events: none;
            }
          }
        }
        .option_button {
          display: flex;
          border-radius: 10px;
          padding: 3px 8px;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;
          overflow: hidden;
          width: 100%;
          box-shadow: 0px 4px 12px -7px rgba(0,0,0,0.1);
          position: relative;
          .col-value {
            width: 60%;
            
            span:nth-child(1) {
              min-height: 50px;
            }
            span {
              display: flex;
              align-items: center;
              justify-content: left;
              font-size: 14px;
              margin-left: 0px;
              font-weight: 500;
              min-height: 0px;
            }
          }
        }
      }
    }
  }
  .optionModal,
  .productModal {
    .productModal__wrapper {
      height: calc(100% - 280px);
      max-height: calc(100% - 280px);
      // max-height: calc(80vh - 180px);
      overflow: auto;
    }
    .productModal__wrapper::-webkit-scrollbar {
        width: 5px;
    }
    .productModal__wrapper::-webkit-scrollbar-thumb {
        border-radius: 100px;
        border: 0px solid transparent;
        background-clip: content-box;
        background-color: var(--principal);
    }
    .productModal__wrapper::-webkit-scrollbar-track {
        background-color: #e4e4e4;
        border-radius: 100px;
    }
    .photo {
      width: calc(100% - 40px);
      height: auto;
      padding-bottom: 80%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: sticky;
      top: 20px;
      z-index: 1;
      margin: 20px;
      border-radius: 20px;
      // max-width: 200px;
      // img {
      //   max-width: 100%;
      //   border-radius: 25px
      // }
    }
    .productModal__product {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      padding: 20px 40px;
      border-top-right-radius: 30px;
      border-top-left-radius: 30px;
      // margin-top: -30px;
      z-index: 2;
      position: relative;
      margin-top: 0;
      .title {
        font-size: 18px;
        font-weight: 500;
      }
      .minMax {
        svg {
          margin-right: 5px;
        }
      }
      .title__wraper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        p {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          line-height: 1.5;
        }
        .title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          p:first-of-type {
            font-size: 3.12rem;
            font-weight: 700;
            max-width: 100%;
            margin: 0;
          }
          p:last-of-type {
            font-size: 26px;
            font-weight: 700;
            color: #000;
            margin: 0;
          }
        }
      }
    }
    .gray__prod_wrapper {
      position: relative;
      z-index: 2;
      margin: 20px;
      margin-top: 0;
      border-radius: 30px;
      overflow: hidden;
    }
    
    .info__wrapper {
      display: flex;
      flex-direction: column;
      padding: 20px;
      z-index: 2;
      position: relative;
      p {
        font-size: 20px;
        font-weight: 400;
        margin: 0;
        text-align: left;
      }
      textarea {
        // border: 1px solid var(--principal);
        font-size: 1.37rem;
        font-weight: 500;
        border: 0;
        border-radius: 20px;
        height: 110px;
        width: 100%;
        resize: vertical;
        padding: 20px;
        &::placeholder {
          font-size: 1.37rem;
          font-weight: 500;
          opacity: 0.5;
          color: #000;
        }
      }
    }
    .other_info {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 0px;
      .info {
        // border: 1px solid var(--principal);
        border: 0;
        border-radius: 20px;
        text-align: left;
        padding: 20px;
        margin-bottom: 20px;
        position: relative;
        background: #fff;
        h2 {
          font-size: 1.62rem;
          font-weight: 500;
          margin: 0;
          color: #000;
          padding-right: 25px;
        }
        .description {
          margin-top: 20px;
          font-size: 1.25rem;
          font-weight: 500;
          overflow-wrap: break-word;
          p {
            line-height: 1.6;
          }
        }
        .other_info_ico {
          svg {
            position: absolute;
            width: 10px;
            right: 20px;
            top: 25px;
            color: #000;
            transition: 0.5s;
            &.closed {
              transform: rotate(45deg);
              transition: 0.5s;
            }
          }
        }
      }
    }
    .footer {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: 2;
      height: 180px;
      background: #F5F5F5;
      .footer__quantity {
        width: 35%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: #fff;
        border-radius: 50px;
        border: 1px solid #DBDBDB;
        span {
          color: #000;
          font-size: 2.75rem;
          font-weight: 500;
          margin-left: 20px;
          margin-right: 20px;
          min-width: 30px;
        }
        button {
          font-size: 2.75rem;
          font-weight: 400;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          background: transparent;
          border: 0;
          border-radius: 10px;
          width: 150px;
          height: 100%;
          padding: 0;
          border-radius: 20px;
          overflow: hidden;
          &:before {
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: #fff;
            opacity: 0.5;
            z-index: -1;
          }
          &:disabled {
            color: #000;
            &:before {
              content: none;
            }
          }
          // &:hover {
          //   border: 2px solid var(--principal);
          //   color: var(--principal);
          // }
        }
      }
      .footer__right {
        width: calc(100% - 20px);
        max-width: 350px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: end;
      }
      .footer__price {
        height: 100%;
        background: #fff;
        color: var(--principal);
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 10px 30px;
        border-radius: 10px;
        box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
        span {
          display: block;
          &:first-of-type {
            font-size: 15px;
            font-weight: 500;
          }
          &:last-of-type {
            font-size: 2.75rem;
            font-weight: 700;
          }
        }
      }
      .footer__addToCart {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          font-size: 18px;
          font-weight: 500;
          color: var(--addBtnColorInv);
          border: 0px;
          border-radius: 50px;
          background: var(--addBtnColor);
          padding: 20px;

          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          span {
            margin-left: 5px;
          }
          svg {
            fill: var(--addBtnColorInv);
            stroke: var(--addBtnColorInv);
            width: 40px;
            height: 40px;
            margin-right: 15px;
          }
          &:disabled {
              opacity: 0.5;
          }
        }
      }
    }
  }
  .addToCart {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    button {
      width: 100%;
    }
    .addToCart__left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 30%;
      height: 100%;
      img {

      }
    }
    .addToCart__right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .total {
        height: 100%;
        background: #fff;
        color: var(--principal);
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 15px 40px;
        border-radius: 20px;
        span {
          display: block;
          &:first-of-type {
            font-size: 1.62rem;
            font-weight: 500;
          }
          &:last-of-type {
            font-size: 2.75rem;
            font-weight: 700;
          }
        }
      }
      .orderNow {
        max-width: 350px;
        width: calc(100% - 20px) !important;
        height: 56px;
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border: 0px;
        border-radius: 50px;
        background: var(--addBtnColor);
        &:disabled {
          opacity: 0.5;
        }
      }
    }
    .total {
      span {
        font-size: 28px;
        font-weight: 500;
        color: var(--principal);
        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
  }
  .couponBtn,
  .orderNow {
    font-size: 20px;
    background: var(--principal);
    color: #fff;
    padding: 10px 40px;
    border: 0;
    border-radius: 50px;
    // @media screen and (max-width: 1800px) {
    //   font-size: 18px;
    //   padding: 18px 38px;
    // }
    // @media screen and (max-width: 1300px) {
    //   font-size: 16px;
    //   padding: 10px 20px;
    // }
    &:disabled,
    &[disabled] {
      opacity: 0.5;
    }
  }
  .couponBtn {
    background: #F3A223;
  }
  .toolbar {
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // -webkit-box-shadow: 0px 0px 30px -10px rgba(0,0,0,0.3);
    // -moz-box-shadow: 0px 0px 30px -10px rgba(0,0,0,0.3);
    // box-shadow: 0px 0px 30px -10px rgba(0,0,0,0.3);
    background: var(--principal);
    z-index: 3;
    padding: 20px 20px;
    .top__toolbar {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }
    // .bottom__toolbar {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   width: 100%;
    //   height: 20px;
    //   .logo__toolbar {
    //     height: 20px;
    //     img {
    //       width: 100%;
    //       height: 100%;
    //     }
    //   }
    // }
    .left__toolbar {
      width: calc(25% - 20px);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .cart_btn {
        position: relative;
        padding: 20px 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: auto;
        min-width: 150px;
        height: 100%;
        &::before {
          content: "";
          background: var(--principal);
          filter: brightness(0.9);
          border-radius: 20px;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
        }
        span {
          color: #fff;
          font-size: 18px;
          font-weight: 700;
        }
      }
      .cart__toolbar {
        position: relative;
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        svg {
          width: 100%;
          fill: var(--principal)
        }
        .roundNr {
          position: absolute;
          top: -10px;
          right: -5px;
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--addBtnColor);
          color: var(--addBtnColorInv);
          font-weight: bold;
          border-radius: 100%;
          font-size: 1.3rem;

          &.bounce {
            -webkit-animation-name: bounce;
            animation-name: bounce;
            -webkit-animation-duration: 2s;
            animation-duration: 2s;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
          }
        }
      }
      // .bar__toolbar {
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   height: 70%;
      //   width: 10px;
      //   margin-left: 20px;
      //   margin-right: 20px;
      //   .bar {
      //     height: 100%;
      //     width: 1px;
      //     // background: var(--secundar);
      //     background: #909090;
      //   }
      // }
      .total__toolbar {
        font-size: 20px;
        font-weight: 600;
        button {
          background: #F3A223;
        }
      }
    }
    .right__toolbar {
      width: 75%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: end;
      .right__toolbar__tot {
        height: 100%;
        background: #fff;
        color: var(--principal);
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        span {
          display: block;
          &:first-of-type {
            font-size: 1.62rem;
            font-weight: 500;
          }
          &:last-of-type {
            font-size: 2.5rem;
            font-weight: 700;
          }
        }
      }
      .right__toolbar__pay {
        width: 290px;
        height: 100%;
        background: var(--addBtnColor);
        font-size: 1.87rem;
        font-weight: 700;
        color: var(--addBtnColorInv);
        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }
  .topBar {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px;
    background: var(--principal);
    color: var(--addBtnColorInv);
    z-index: 22;
    position: relative;
    .backButton {
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .cart {
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .roundNr {
        background: red;
        color: #fff;
        border-radius: 50px;
        width: 18px;
        height: 18px;
        font-weight: 800;
        line-height: 18px;
        position: absolute;
        top: 15px;
        right: 8px;
      }
    }
    .title {
      color: #fff;
      font-size: 22px;
    }
    .topBar__left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .topBar__back {
      margin-right: 20px;
      svg {
        fill: var(--principal);
        width: 40px;
      }
    }
    .topBar__title {
      font-size: 3.12rem;
      font-weight: 300;
    }
  }
  .lang_btn {
    position: relative;
    width: 40px;
    height: 40px;
    a,
    img {
      width: 100%;
      height: 100%;
    }

    .listOfLang {
      opacity: 0;
      position: absolute;
      top: 0;
      right: 100%;
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s;
      a {
        position: absolute;
        top: 0;
        right: -50px;
        width: 40px;
        height: 40px;
        transform: scale(0);
        transform-origin: center;
        margin-right: 10px;
        transition: 0.3s;
      }
    }
    >a>img {
      transform: scale(1);
      transition: 0.5s;
    }
    &.open {
      >a>img {
        transform: scale(1.2);
        transition: 0.5s;
      }
      .listOfLang {
        opacity: 1;
        transition: 0.5s;
        a {
          position: relative;
          right: 0;
          transform: scale(1);
          transform-origin: center;
          transition: 0.5s;
        }
      }
    }
  }
  .orderspos {
    display: flex;
    height: calc(100% - 640px);  // -banner - footer + 40margin
    flex-direction: column;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    margin-top: -40px;
    // padding-top: 20px;
    z-index: 2;
    background: #F5F5F5;
    &.noBanner {
      margin-top: 0px;
      height: calc(100% - 180px);  // -Footer
      &.noToolbar {
        height: calc(100%);
      }
    }
    &.noToolbar {
      height: calc(100% - 460px); // -banner+40margin
    }
  }

  .cartDetail {
    height: 100%;
    // height: calc(100% - 220px);
    // min-height: calc(80vh - 480px);
    min-height: calc(100vh - 280px);
    .tipsBox {
      border-top: 1px solid #DFDFDF;
      .tipsInputsTitle {
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        // color: green;
        // span {
        //   text-decoration: underline;
        // }
      }
      .custom-tip-input {
        margin-bottom: 10px;
      }
      .tipsInputs {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        .col {
            background: #fff;
            padding: 7px;
            border-radius: 50px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 110px;
            border: 1px solid #DFDFDF;
            font-size: 18px;
            font-weight: 600;
            margin: 10px;
            img {
              max-width: 27px;
            }
        }
        .col.selected {
          background: var(--addBtnColor);
          color: var(--addBtnColorInv);
        }
        .col.disabled {
          opacity: 0.3;
          user-select: none;
          pointer-events: none;
        }
      }
      .tipsInputs.disabled {
          opacity: 0.3;
          user-select: none;
          pointer-events: none;
      }
      .custom-tip-input {
        input {
          border-radius: 50px;
          font-size: 14px;
          height: 43px;
          padding: 5px 20px;
          margin: 5px 0px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
        button {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 43px;
          padding: 10px 20px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
        }
      }
      .custom-tip-input.disabled {
        opacity: 0.3;
        user-select: none;
        pointer-events: none;
      }
      .tips {
        font-size: 18px;
        background: transparent;
        color: green;
        text-decoration: underline;
        padding-top: 0px;
      }
    }
    .commentClientsBox {
       border-top: 1px solid #DFDFDF;
      .commentClientsTitle {
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        color: #000;
        span {
          text-decoration: underline;
        }
      }
      .inputComment {
        textarea {
          font-size: 1.37rem;
          font-weight: 500;
          border: 0;
          border-radius: 20px;
          height: 110px;
          resize: vertical;
          padding: 20px;
          margin: 0 20px;
          width: calc(100% - 40px);
          margin-bottom: 20px;
        }
      }
    }
    .couponBox {
      .couponInputsTitle {
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        color: green;
        span {
          text-decoration: underline;
        }
      }
      .inputCoupn {
        input {
          font-size: 14px;
          height: 43px;
          padding: 5px 20px;
          margin: 5px 0px;
          margin-bottom: 10px;
          border-radius: 50px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
        button {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 43px;
          padding: 10px 20px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
        }
      }
    }
    .totalCart {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: calc(100% - 40px);
      padding-left: 30px;
      font-size: 18px;
      font-weight: 600;
      border-top: 1px solid #DFDFDF;
      border-bottom: 1px solid #DFDFDF;
      margin: 0 20px;
      padding: 18px 0px;
      .totalsOptions {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        span {
          font-weight: 500;
        }
      }
    }
    .orderTotal {
      display: flex;
      justify-content: space-between;
      span {
        font-weight: 600;
        font-size: 22px;
      }
    }
  }
  .pre__footer {
    width: 100%;
    // height: 300px;
    height: auto;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 20px;
    .pre__footer__l {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: center;
      width: calc(50% - 5px);
      button {
        max-width: 300px;
      }
    }
    .pre__footer__r {
      // display: flex;
      // flex-direction: column;
      // align-items: flex-end;
      // justify-content: center;
      display: block;
      text-align: right;

      border-radius: 20px;
      width: calc(50% - 5px);
      .pre__footer__r__colorbox {
        // background: #F9F9F9;
      }
    }
    .totalsOptions {
      margin: 20px;
      span {
        font-size: 1.87rem;
        font-weight: 400;
        &:first-of-type {
          margin-right: 20px;
        }
        &:last-of-type {
          font-weight: 600;
        }
      }
    }
    .tips {
      background: transparent !important;
      color: #0f6015 !important;
      text-decoration: underline !important;
      font-weight: 500 !important;
    }
    .tips,
    .couponBtn {
      font-size: 18px;
      font-weight: 600;
      padding: 20px 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      background: transparent;
      text-decoration: underline;
      margin-left: auto;
      border: none;
      font-weight: 300;
      margin-top: 20px;
      border-radius: 50px;
    }
    .tips {
      padding: 10px;
      margin-top: 5px;
      background: var(--principal);
      color: #fff;
    }
    .emptyCart {
      font-size: 1.62rem;
      font-weight: 500;
      padding: 20px 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ff0000;
      background: #fff;
      border: 1px solid #ff0000;
      svg {
        fill: #ff0000;
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
  .footer {
    height: 180px;
    padding: 20px;
    background: #f5f5f5;
  }
  .cartDetail__head {
    height: 150px;
  }
  .products {
    height: calc(100% - 150px);
    max-height: calc(100vh - 150px);
    overflow: auto;
  }
  .products::-webkit-scrollbar {
      width: 5px;
  }
  .products::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 0px solid transparent;
      background-clip: content-box;
      background-color: var(--principal);
  }
  .products::-webkit-scrollbar-track {
      background-color: #e4e4e4;
      border-radius: 100px;
  }

  .cartDetail_wrapper,
  .productList_wrapper {
    width: 100%;
    // height: calc(100% - 40px);
    height: 100%;
    position: relative;
    display: flex;
    &.disabled {
      opacity: 0.3;
      user-select: none;
      pointer-events: none;
    }
  }
  // .noBanner {
  //   .cartDetail_wrapper,
  //   .productList_wrapper {
  //     height: calc(100% - 80px);
  //   }
  // }
  .productList_wrapper {
    border-radius: 20px;
    padding-bottom: 0;
    .productList_wrapper_left {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 0;
      padding-right: 0;
      background: #f5f5f5;
      border-top-left-radius: 50px;
      // .productList_filter {
      //   height: 60px;
      //   min-height: 60px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: flex-start;
      //   padding-left: 10px;
      //   h3 {
      //     margin: 0;
      //   }
      // }
    }
    .productList_wrapper_right {
      width: 75%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding-left: 10px;
      padding-right: 10px;
      // padding-bottom: 10px;
      // box-shadow: inset 10px -10px 30px -30px rgb(0 0 0 / 30%);
    }
    .search_topBar {
      height: 45px;
      margin-top: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      .search_wrapper {
        width: calc(100% - 20px);
        display: flex;
        flex-direction: row;
      }
      .searchBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: all;
        cursor: pointer;
        z-index: 2;
        margin-top: 5px;
        margin-left: 1px;
        .circle {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          background: #ECECEC;
          margin-bottom: 10px;
          // &:hover {
          //   background: var(--principal);
          //   svg {
          //     color: #fff;
          //     fill: #fff;
          //     * {
          //       stroke: #fff;
          //     }
          //   }
          // }
          &.used {
            background: var(--principal);
            svg * {
              stroke: #fff;
              color: #fff;
              fill: #fff;
            }
          }
          svg {
            margin: 0;
            width: 20px;
            color: #777777;
            fill: #777777;
            * {
              stroke: #777777;
            }
          }
        }
        // svg {
        //   margin-bottom: 10px;
        //   @media screen and (max-width: 1800px) {
        //     width: 50px;
        //     height: 50px;
        //   }
        //   @media screen and (max-width: 1300px) {
        //     width: 40px;
        //     height: 40px;
        //   }
        // }
      }
      .filter__search {
        // width: calc(100% - 20px);
        width: 100%;
        display: none;
        align-items: center;
        justify-content: flex-start;
        // background: #fff;
        // margin-left: 20px;
        &.showw {
          display: flex;
        }
        .search {
          position: relative;
          width: 100%;
          margin-top: 0;
          margin-bottom: 0;
          display: flex;
          button {
            padding: 0px;
            width: 140px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            font-size: 16px;
            box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
          }
          input {
            width: 100%;
            padding-left: 50px;
            padding-right: 50px;
            border-radius: 28px;
            border: 1px solid #EEEEEE;
            background: transparent;
            background: #fff;
            height: 45px;
            font-size: 16px;
            font-weight: 500;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
            &::placeholder {
              color: rgb(0 0 0 / 37%);
              font-size: 16px;
              font-weight: 500;
              opacity: 1; /* Firefox */
            }
          }
          .icosearch {
            height: 20px;
            position: absolute;
            left: 15px;
            top: calc(50% - 11px);
            svg {
              width: auto;
              height: 100%;
              fill: var(--principal);
              stroke: var(--principal);
            }
          }
          .closeSearch {
            height: 20px;
            position: absolute;
            right: 110px;
            top: calc(50% - 10px);
            opacity: 0;
            transition: 0.5s;
            display: flex;
            align-items: center;
            &.show {
              opacity: 1;
              transition: 0.5s;
            }
            svg {
              width: auto;
              height: 70%;
              fill: var(--principal);
            }
          }
        }
      }
    }
  }
  .zoom {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    svg {
      @media screen and (max-width: 1800px) {
        width: 48px;
        height: 50px;
      }
      @media screen and (max-width: 1300px) {
        width: 38px;
        height: 40px;
      }
    }
  }
  .productList::-webkit-scrollbar {
      width: 0px;
      // width: 5px;
  }
  .productList::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 0px solid transparent;
      background-clip: content-box;
      background-color: var(--secundar);
  }
  .productList::-webkit-scrollbar-track {
      background-color: #f1f1f1;
      border-radius: 100px;
  }
  .productList__wrapper {
    position: relative;
    display: flex;
    width: 100%;
    height: calc(100% - 170px);
    // margin-top: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    &.activeTop {
      &::before {
        opacity: 1;
        transition: 0.7s;
      }
    }
    &.activeBottom {
      &::after {
        opacity: 1;
        transition: 0.7s;
      }
    }
    &::after,
    &::before {
      // content: "";
      position: absolute;
      left: 0;
      width: 100%;
      height: 50px;
      // filter: blur(30px);
      // backdrop-filter: opacity(0.5);
      /* backdrop-filter: blur(1px); */
      background: transparent;
      opacity: 0;
      transition: 0.7s;
      pointer-events: none;
      z-index: 3;
    }
    &::after {
      bottom: -1px;
      // background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      background: linear-gradient(0deg, rgb(241 241 241) 0%, rgba(0, 212, 255, 0) 100%);
    }
    &::before {
      top: -1px;
      // background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      background: linear-gradient(180deg, rgb(241 241 241) 0, rgba(0, 212, 255, 0) 100%);
    }
  }
  .productList {
    position: relative;
    width: 100%;
    height: 100%;
    // height: calc(100% - 50px); // +10px For Custom Scrool
    overflow: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-top: 0px;
    padding-bottom: 0px;
    // padding-bottom: 30px; // for swipeUpForMore
    // margin-right: 10px; // For Custom Scrool
    .no-products-found {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 20px;
    }
    .productcat {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      overflow: hidden;
      >span {
        width: 100%;
        border-bottom: 1px solid #000;
        padding-top: 20px;
        padding-bottom: 5px;
        padding-left: 10px;
        margin-bottom: 10px;
      }
    }
    .product {
      width: calc(20% - 20px);
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 20px;
      position: relative;
      height: auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      text-align: center;
      justify-content: space-between;

      background: transparent;
      border-radius: 10px;
      @media screen and (max-width: 1800px) {
        width: calc(33.33% - 20px);
      }
      @media screen and (max-width: 1400px) {
        width: calc(50% - 20px);
      }
      @media screen and (max-width: 900px) {
        width: calc(50% - 20px);
      }
      @media screen and (max-width: 500px) {
        width: calc(100% - 20px);
      }
      transition: 0s;
      overflow: hidden;
      position: relative;
      &.pressed{
        // transform: translate(0px,0px) scale(0.7);
        // -webkit-transform: translate(0px,0px) scale(0.7);
        // transition: 0.5s !important;
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          -webkit-animation: effect-animation 1s;
          background: #fff;
          opacity: 0;
          z-index: 3;
        }
      }
      .product_img_title {
        width: 100%;
        display: flex;
        align-items: center;
        position: relative;
        padding: 14px;
        border-radius: 20px;
        background: #fff;
      }
      .productImage__wrapper {
        position: relative;
        width: 100%;
        height: 350px;
        @media screen and (max-width: 500px) {
          height: 200px;
        }
        // margin-bottom: 10px;
      }
      .productImage {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 10px;
        user-select: none;
        position: relative;
        z-index: 2;
        margin: 0;
      }
      // .rectangle {
      //   border-radius: 20px;
      //   background: var(--secundar);
      //   opacity: .5;
      //   width: 100%;
      //   height: 55%;
      //   position: absolute;
      //   left: 0;
      //   bottom: 0;
      //   z-index: 1;
      //   display: none;
      // }
      img {
        border-radius: 20px;
        margin-bottom: 10px;
      }
      p {
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0;
        &.prod_title {
          font-size: 1.75rem;
          font-weight: 700;
          color: #000;
          width: 100%;
          // margin-top: -20px;
          margin-top: 20px;
          margin-bottom: 20px;
          // padding: 2px 10px;
          // background: #fff;
          // z-index: 2;
          // border-top-right-radius: 20px;
          // border-top-left-radius: 20px;
          // border-radius: 20px;
          // border: 1px solid var(--principal);
        }
        &.discount_badge {
          position: absolute;
          top: 0px;
          right: 7px;
          transform: rotate(-45deg);
          font-size: 12px;
          font-weight: 600;
          color: #fff;
          width: 122px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 3;
          &:before {
            content: "";
            position: absolute;
            right: 7px;
            top: 0px;
            width: 100%;
            height: 20px;
            background: red;
            z-index: -1;
          }
        }
        &.old_prod_price {
          font-size: 1.5rem;
          font-weight: 500;
          position: relative;
          color: red;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 1px;
            background: red;
          }
        }
        &.prod_price {
          font-size: 18px;
          font-weight: 600;
          padding: 5px 10px;
          border-radius: 5px;
          margin-bottom: 20px;
          color: #000;
          // position: absolute;
          // top: 10px;
          // right: 10px;
          // z-index: 2;
          // &:before {
          //   content: "";
          //   background: var(--principal);
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   width: 100%;
          //   height: 100%;
          //   z-index: -1;
          //   opacity: 0.7;
          // }
        }
      }
    }
  }
  .filter {
    width: 100%;
    // height: calc(100% - 60px);
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    padding-left: 0;
    .settings {
      position: absolute;
      left: 2px;
      bottom: 2px;
      width: 50px;
      height: 50px;
      z-index: 999;
      padding: 30px;
      padding-left: 2px;
      padding-bottom: 2px;
    }
    .logo_f {
      width: 100%;
      height: 170px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      border-bottom: 1px solid #D4D4D4;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .filter__bar {
      width: 100%;
      height: calc(100% - 170px);
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      position: relative;
      &.activeTop {
        &::before {
          opacity: 1;
          transition: 0.7s;
        }
      }
      &.activeBottom {
        &::after {
          opacity: 1;
          transition: 0.7s;
        }
      }
      &::after,
      &::before {
        content: "";
        position: absolute;
        left: 0;
        width: 100%;
        height: 50px;
        // filter: blur(30px);
        // backdrop-filter: opacity(0.5);
        /* backdrop-filter: blur(1px); */
        background: transparent;
        opacity: 0;
        transition: 0.7s;
        pointer-events: none;
      }
      &::after {
        bottom: 0;
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      }
      &::before {
        top: 0;
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      }
      a {
        display: flex;
        align-items: stretch;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 100%;
        border-radius: 10px;
        min-height: auto;
        padding: 20px 5px;
        box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
        &.selected {
          background: var(--principal);
          p {
            color: #fff;
          }
        }
      }
      .cat_photo {
        width: 80px;
        height: 80px;
        background-position: center;
        background-size: cover;
        background-color: transparent;
        background-repeat: no-repeat;
        border-radius: 100%;
      }
      p {
        text-overflow: ellipsis;
        overflow: hidden;
        height: auto;
        width: 60%;
        padding: 8px;
        padding-bottom: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        color: #000;
        font-size: 1.37rem;
        font-weight: 700;
        // @media screen and (max-width: 1400px) {
        //   padding: 8px 10px;
        //   font-size: 12px;
        // }
        // @media screen and (max-width: 1300px) {
        //   padding: 5px 8px;
        // }
      }
      .filter__cat {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        height: 100%;
        width: 100%;
        overflow: auto;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 20px;
        .topGroup {
          position: relative;
          border-radius: 20px;
          display: flex;
          flex-direction: column;
          width: 100%;
          &.active {
            .childs {
              height: 100%;
            }
            a {
              margin-bottom: 10px;
            }
          }
          &.active::after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: var(--principal);
            opacity: 0.5;
            pointer-events: none;
            border-radius: 20px;
            z-index: 1;
          }
        }
        a {
          position: relative;
          z-index: 2;
          margin: 0;
        }
        .childs {
          position: relative;
          z-index: 2;
          margin-left: 15px;
          width: calc(100% - 30px);
          height: 0;
          overflow: hidden;
          a {
            padding: 5px;
          }
        }
      }
      .filter__cat::-webkit-scrollbar {
          width: 0px; // Vertical
          height: 0px; // Horizontal
          // width: 5px;
      }
      .filter__cat::-webkit-scrollbar-thumb {
          border-radius: 100px;
          border: 0px solid transparent;
          background-clip: content-box;
          background-color: var(--secundar);
      }
      .filter__cat::-webkit-scrollbar-track {
          background-color: #f1f1f1;
          border-radius: 100px;
      }
    }
  }
  .show-loader {
    position: absolute;
    position: sticky;
    display: inline-block;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    backdrop-filter: blur(3px);

    .el-loading-spinner{
      z-index: 2001;
    }
    &:after{
      content: '';
      display: inline-block;
      position: absolute;
      width: calc(100% - 20px);
      margin: auto;
      top:0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(255,255,255,0.5);
      z-index: 2000;
      border-radius: 30px;
      margin: 0 10px;
    }
  }
  .el-loading-spinner {
    z-index: 2001;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    svg {
      width: 30%;
      height: 30%;
      fill: var(--principal);
    }
  }

  .hide-loader{
    .el-loading-spinner{
      display: none;
    }
  }
  .cartModal {
    .cartDetail {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .cart__wrapper {
      background: #F5F5F5;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }
    .cartDetail__head {
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .cartTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 5px;
        p {
          font-size: 3.12rem;
          font-weight: 700;
          margin-bottom: 0px;
          margin-top: 10px;
          text-transform: uppercase;
        }
      }
      .packing_method {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;
        margin-bottom: 20px;
        span {
          font-size: 1.37rem;
          font-weight: 400;
          color: #000;
        }
      }
    }
    .no_products_in_cart {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      p {
        font-size: 24px;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 50px;
      }
      button {
        background: var(--principal);
        margin-top: 50px;
      }
      .middle {
        width: 40vw;
        height: 40vw;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 50px;
        &:after {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          background: var(--principal);
          border-radius: 100%;
          z-index: 1;
          opacity: 30%;
        }
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          height: 80%;
          background: var(--principal);
          border-radius: 100%;
          z-index: 2;
          opacity: 80%;
        }
        svg {
          width: 50%;
          height: 50%;
          fill: #fff;
          position: relative;
          z-index: 3;
        }
      }
    }
    .products {
      padding: 10px;
      .product {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        border-radius: 0px;
        padding: 20px;
        margin-bottom: 0px;
        .product_details_wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          .col-image {
            width: 20%;
            padding-right: 10px;
          }
          .col-info {
            width: 80%
          }
        }
        .product__photo {
          width: 20%;
          min-height: 105px;
          max-height: 250px;
          border-radius: 20px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
        .description {
          width: 40%;
        }
        .product_details {
          width: 40%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: space-around;
        }
        .product__name {
          font-size: 20px;
          font-weight: 600;
          display: block;
          text-align: left;
        }
        .product__is_bonus,
        .product__additional_info,
        .product__extra {
          display: block;
          text-align: left;
          font-size: 14px;
          margin-top: 10px;
        }
        .product_price {
          font-size: 2.25rem;
          font-weight: 700;
          color: #000;
        }
        .quantity {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-top: 0;
          margin-bottom: 0;
          background: #fff;
          border-radius: 50px;
          border: 1px solid #DBDBDB;
          svg {
            width: 18px;
            height: 18px;
            fill: red;
          }
          span {
            color: #000;
            font-size: 1.56rem;
            font-weight: 700;
            margin-left: 10px;
            margin-right: 10px;
            min-width: 20px;
          }
          button {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
            background: transparent;
            border: 0;
            // border-radius: 10px;
            width: 40px;
            height: 42px;
            font-size: 25px;
            font-weight: 500;
            padding: 0;
            &:disabled {
              opacity: 0.2;
              // color: var(--secundar);
              // border-color: var(--secundar);
            }
            // &:hover {
            //   border: 2px solid var(--principal);
            //   color: var(--principal);
            // }
          }
        }
        .product_right {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin-top: 20px;
          svg {
            // fill: #fff;
            width: 25px;
            height: auto;
            margin-right: 5px;
          }
          button {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 15px;
          }
          .product__modify {
            font-size: 1.50rem;
            font-weight: 500;
            background: #ECEBEB;
            color: #000;
            border-radius: 10px;
          }
          .product__delete {
            font-size: 1.50rem;
            font-weight: 500;
            background: #ECEBEB;
            color: #000;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .paymentModal {
    .din,
    .take {
      border: 1px solid var(--secundar);
      box-shadow: none;
    }
    .top__payment {
      width: 100%;
      height: 30%;
      background: var(--secundar);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-bottom: 10%;
      .model {
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 20%;
          height: auto;
          margin-bottom: 3.12rem;
        }
      }
      // img {
      //   max-width: 300px;
      //   max-height: 300px;
      // }
      h2 {
        font-size: 28px;
        font-weight: 400;
      }
    }
    .backShopping {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 180px;
      padding: 20px;
      button {
        background: transparent;
        color: var(--addBtnColorInv);
        font-size: 1.87rem;
        font-weight: 700;
        background: var(--addBtnColor);
        border-radius: 20px;
        padding: 30px 50px;
        height: 100%;
      }
    }
  }
  .p9Modal {
    .iframeModal__wrapper {
      height: 100%;
    }
    .settings_buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      // background: #fff;
      background: linear-gradient(90deg, rgba(194,159,131,1) 0%, rgba(124,83,62,1) 100%);
      color: #fff;
      padding: 20px;
      img {
        max-width: 70%;
        margin-bottom: 30px;
      }
      h2 {
        font-weight: 400;
        letter-spacing: 1px;
      }
      .settings_buttons_btn2,
      .settings_buttons_btn1 {
        background: #fff;
        color: #000;
        padding: 10px 30px;
        margin-top: 30px;
        font-weight: 400;
        letter-spacing: 1px;
      }
      .settings_buttons_btn2 {
        background: #000;
        color: #fff;
      }
    }
  }
  .settingsModal {
    .settings_buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding-top: 100px;
      font-size: 5rem;
      input {
        font-size: 5rem;
      }
      button {
        background: var(--principal);
        font-size: 5rem;
      }
    }
  }
  .payment__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    padding-top: 50px;
    .selected {
      background: var(--addBtnColor) !important;
      color: var(--addBtnColorInv);
    }
    .disabled {
      opacity: 0.3;
      user-select: none;
      pointer-events: none;
    }
    .pack__wrapper__buttons_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120%;
      margin-top: -6.25rem;
      min-height: 500px;
    }
    .free,
    .pos,
    .din,
    .take {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 0;
      background: #fff;
      border-radius: 30px;
      z-index: 2;
      -webkit-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      /* max-width: 22rem; */
      width: 50%;
      margin-bottom: 50px;
      min-height: 72px;
      &.disabled {
        user-select: none;
        opacity: 0.5;
      }
      svg {
        left: 10px;
        top: 10px;
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
        fill: var(--secundar);
      }
      img {
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
      }
      &.loading {
        span {
          //display: none;
        }
        svg {
          left: calc(50% - 25px);
          transition: 2s;
        }
      } 
    }
    span {
      font-size: 3rem;
      font-weight: 600;
      margin-top: 0.62rem;
      text-align: left;
    }
  }
  .pack__wrapper__buttons {
    display: flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    position: relative;
    padding-top: 50px;
    .pack__wrapper__buttons_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120%;
      margin-top: -1.25rem;
      svg {
        width: 100%;
        height: 100%;
        fill: var(--principal);
        filter: brightness(0.9);
      }
    }
    .free,
    .pos,
    .din,
    .take {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding: 6.250rem 3.125rem;
      background: #fff;
      border-radius: 30px;
      z-index: 2;
      -webkit-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      max-width: 22rem;
      margin: 0 40px;
      min-height: 500px;
      svg {
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
        fill: var(--iconsColor1);
        transition: 1s;
      }
      img {
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
      }
    }
    span {
      font-size: 3rem;
      font-weight: 600;
      margin-top: 0.62rem;
    }
  }
  .splashScreenModal {
    .pack__wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      .lang_btn {
        position: absolute;
        right: 30px;
        top: 30px;
        width: 40px;
        height: 40px;
        z-index: 2;
        a,
        img {
          width: 100%;
          height: 100%;
        }

        .listOfLang {
          opacity: 0;
          position: absolute;
          top: 0;
          right: 100%;
          width: auto;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.3s;
          a {
            position: absolute;
            top: 0;
            right: -50px;
            width: 40px;
            height: 40px;
            transform: scale(0);
            transform-origin: center;
            margin-right: 10px;
            transition: 0.3s;
          }
        }
        >a>img {
          transform: scale(1);
          transition: 0.5s;
        }
        &.open {
          >a>img {
            transform: scale(1.2);
            transition: 0.5s;
          }
          .listOfLang {
            opacity: 1;
            transition: 0.5s;
            a {
              position: relative;
              right: 0;
              transform: scale(1);
              transform-origin: center;
              transition: 0.5s;
            }
          }
        }
      }
      .splash_bg {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      .bg_splash_wrapper {
        width: 100%;
        height: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
      }
      .top__pack__wrapper {
        height: 35%;
        background: var(--secundar);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-bottom: 10%;
        .model {
          background-position: center;
          background-size: cover;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20%;
            height: auto;
            margin-bottom: 3.12rem;
          }
        }
        // img {
        //   max-width: 300px;
        //   max-height: 300px;
        // }
        h2 {
          font-size: 28px;
          font-weight: 400;
        }
      }
      .round {
        width: 100%;
        height: 75%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding-top: 5%;
        .logo_t {
          position: absolute;
          left: 0;
          bottom: 5%;
          width: 100%;
        }
        .total {
          margin-top: 30px;
          margin-bottom: 50px;
          font-size: 24px;
          font-weight: 400;
          color: var(--principal);
          span:first-child  {
            margin-right: 10px;
          }
        }
        h2 {
          position: relative;
          color: #fff;
          font-size: 3rem;
          font-weight: 400;
          margin-bottom: 70px;
          z-index: 2;
        }
        .roundbg {
          width: 200%;
          height: 100%;
          background: var(--principal);
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          bottom: 0;
          border-top-right-radius: 50%;
          border-top-left-radius: 50%;
        }
      }
    }
    .splashScreen__wrapper {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      &.hiden {
        opacity: 0;
        width: 0;
        height: 0;
      }
      &.defaultOne {
        .model {
          width: 100%;
          height: auto;
          position: absolute;
          left: 0;
          top: 15%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: auto;
            height: auto;
            max-width: 200px;
            margin: auto;
          }
        }
        .text {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 20%;
          position: absolute;
          left: 0;
          bottom: 0;
          p {
            margin: 0;
            color: #fff;
            font-size: 3em;
            width: 50%;
          }
        }
      }
    }
  }
  button {
    background: var(--principal);
    border-radius: 20px;
    border: 0;
    padding: 15px 40px;
    color: #fff;
    font-weight: 600;
  }
  .complete__wrapper {
    height: 100%;
    .dialog {
      position: relative;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 400px;
      height: 90px;
      font-size: 1.37rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      margin-right: 15%;
      span {
        margin-bottom: 15px
      }
    }
    .top__pack__wrapper {
      width: 100%;
      height: 35%;
      background: var(--secundar);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-bottom: 10%;
      .model {
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 20%;
          height: auto;
          margin-bottom: 3.12rem;
        }
      }
      h2 {
        font-size: 28px;
        font-weight: 400;
      }
      .pack__wrapper__buttons_bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 120%;
        margin-top: -4.25rem;
        min-height: 500px;
      }
      .round {
        width: 100%;
        height: 75%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding-top: 5%;
        overflow: hidden;
        .logo_t {
          position: absolute;
          left: 0;
          bottom: 5%;
          width: 100%;
        }
        .total {
          margin-top: 30px;
          margin-bottom: 50px;
          font-size: 24px;
          font-weight: 400;
          color: var(--principal);
          span:first-child  {
            margin-right: 10px;
          }
        }
        h2 {
          position: relative;
          color: #fff;
          // font-family: 'Devitta';
          font-size: 7.31rem;
          font-weight: 400;
          z-index: 2;
          margin-top: -25px;
          margin-bottom: 120px;
        }
        .roundbg {
          width: 200%;
          height: 100%;
          background: var(--principal);
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          bottom: 0;
          border-top-right-radius: 50%;
          border-top-left-radius: 50%;
        }
      }
    }
    h2 {
      font-size: 30px;
      color: var(--principal);
      font-weight: 500;
      margin: 0;
      margin-top: 70px;
    }
    p {
      font-size: 26px;
      color: var(--principal);
      font-weight: 400;
      margin: 0;
    }
    .order_nr_wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .order_nr {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        svg {
          position: relative;
        }
        .order_nr_txt {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          // padding-right: 30%;
        }
        span {
          font-size: 1.50rem;
          font-weight: 300;
          color: #000;
          &:last-of-type {
            font-size: 7.00rem;
            font-weight: 500;
            color: #000;
          }
        }
      }
    }
    .steps {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 50%;
      position: relative;
      margin: auto;
      margin-top: 100px;
      .step {
        padding-bottom: 20px;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
          font-size: 2.18rem;
          font-weight: normal;
          color: #fff;
        }
        .step_round {
          font-size: 1.56rem;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          background: var(--addBtnColor);
          color: var(--addBtnColorInv);
          width: 40px;
          height: 40px;
        }
      }
    }
    .back {
      position: relative;
      margin-top: 50px;
      button {
        background: var(--addBtnColor);
        font-size: 2rem;
        color: var(--addBtnColorInv);
      }
    }
  }
  .error_page {
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20%;
    padding-left: 10px;
    padding-right: 10px;
  }
</style>